/* tslint:disable */
/* eslint-disable */

/**
 * 
 * @export
 */
export const AccessRuleProtocol = {
    Tcp: 'Tcp',
    Udp: 'Udp',
    Icmp: 'Icmp',
    Sctp: 'Sctp',
    Igmp: 'Igmp',
    IpInIP: 'IpInIP',
    Egp: 'Egp',
    Igp: 'Igp',
    Gre: 'Gre',
    Esp: 'Esp',
    Ah: 'Ah'
} as const;
export type AccessRuleProtocol = typeof AccessRuleProtocol[keyof typeof AccessRuleProtocol];


/**
 * 
 * @export
 */
export const AccountPermissions = {
    ReadOnly: 'ReadOnly',
    Full: 'Full'
} as const;
export type AccountPermissions = typeof AccountPermissions[keyof typeof AccountPermissions];

/**
 * 
 * @export
 * @interface AddDnsSearchDomainRequest
 */
export interface AddDnsSearchDomainRequest {
    /**
     * The domain to use as search domain
     * 
     * It must be a FQDN without a trailing dot.
     * @type {string}
     * @memberof AddDnsSearchDomainRequest
     */
    domain: string;
    /**
     * The index to insert the domain at
     * @type {number}
     * @memberof AddDnsSearchDomainRequest
     */
    index: number;
}
/**
 * 
 * @export
 * @interface AddExtraDnsError
 */
export interface AddExtraDnsError {
    /**
     * If an existing device has the same name
     * @type {boolean}
     * @memberof AddExtraDnsError
     */
    device_already_exists: boolean;
    /**
     * If an existing domain has the same name
     * @type {boolean}
     * @memberof AddExtraDnsError
     */
    domain_already_exists: boolean;
    /**
     * Invalid domain
     * @type {boolean}
     * @memberof AddExtraDnsError
     */
    domain_invalid: boolean;
    /**
     * The ip of the record is not a valid ip
     * @type {boolean}
     * @memberof AddExtraDnsError
     */
    ip_invalid: boolean;
    /**
     * If the IP is in the internal range but no device exists
     * @type {boolean}
     * @memberof AddExtraDnsError
     */
    no_internal_device: boolean;
}
/**
 * 
 * @export
 * @interface AddExtraDnsRecordRequest
 */
export interface AddExtraDnsRecordRequest {
    /**
     * The record type, A or AAAA accepted
     * @type {ExtraDnsRecordType}
     * @memberof AddExtraDnsRecordRequest
     */
    record_type: ExtraDnsRecordType;
    /**
     * The IP of the Record
     * @type {string}
     * @memberof AddExtraDnsRecordRequest
     */
    to_ip: string;
}
/**
 * 
 * @export
 * @interface AddExtraDnsRequest
 */
export interface AddExtraDnsRequest {
    /**
     * Description
     * @type {string}
     * @memberof AddExtraDnsRequest
     */
    description: string;
    /**
     * The fully qualified domain name
     * @type {string}
     * @memberof AddExtraDnsRequest
     */
    from_dns: string;
    /**
     * The record type, A or AAAA accepted
     * 
     * Ignored if `to_ip` is empty`
     * @type {ExtraDnsRecordType}
     * @memberof AddExtraDnsRequest
     */
    record_type: ExtraDnsRecordType;
    /**
     * The IP of the Record
     * 
     * MAY be empty to create a domain without a record
     * @type {string}
     * @memberof AddExtraDnsRequest
     */
    to_ip: string;
}
/**
 * Add member to local group errors
 * @export
 * @interface AddMemberToLocalGroupError
 */
export interface AddMemberToLocalGroupError {
    /**
     * The name is not unique
     * @type {boolean}
     * @memberof AddMemberToLocalGroupError
     */
    already_part_of_group: boolean;
}
/**
 * The response that is sent in a case of an error the caller should report to an admin
 * @export
 * @interface ApiErrorResponse
 */
export interface ApiErrorResponse {
    /**
     * ID of the opentelemetry trace this error originated in
     * @type {string}
     * @memberof ApiErrorResponse
     */
    trace_id: string;
}

/**
 * 
 * @export
 */
export const ChangelogOperation = {
    Create: 'Create',
    Update: 'Update',
    Delete: 'Delete'
} as const;
export type ChangelogOperation = typeof ChangelogOperation[keyof typeof ChangelogOperation];


/**
 * 
 * @export
 */
export const ChangelogTarget = {
    PreAuthKey: 'PreAuthKey',
    Tag: 'Tag',
    SettingsLdap: 'SettingsLdap',
    SettingsLdapConnection: 'SettingsLdapConnection',
    Device: 'Device',
    Account: 'Account',
    AccessRule: 'AccessRule',
    Group: 'Group',
    Subnet: 'Subnet',
    User: 'User',
    GlobalDns: 'GlobalDns',
    SplitDns: 'SplitDns'
} as const;
export type ChangelogTarget = typeof ChangelogTarget[keyof typeof ChangelogTarget];

/**
 * @type CreateAccessRuleDst
 * 
 * @export
 */
export type CreateAccessRuleDst = CreateAccessRuleDstOneOf | CreateAccessRuleDstOneOf1 | CreateAccessRuleDstOneOf2;
/**
 * 
 * @export
 * @interface CreateAccessRuleDstOneOf
 */
export interface CreateAccessRuleDstOneOf {
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRuleDstOneOf
     */
    type: CreateAccessRuleDstOneOfTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRuleDstOneOf
     */
    value: string;
}


/**
 * @export
 */
export const CreateAccessRuleDstOneOfTypeEnum = {
    Group: 'Group'
} as const;
export type CreateAccessRuleDstOneOfTypeEnum = typeof CreateAccessRuleDstOneOfTypeEnum[keyof typeof CreateAccessRuleDstOneOfTypeEnum];

/**
 * 
 * @export
 * @interface CreateAccessRuleDstOneOf1
 */
export interface CreateAccessRuleDstOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRuleDstOneOf1
     */
    type: CreateAccessRuleDstOneOf1TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRuleDstOneOf1
     */
    value: string;
}


/**
 * @export
 */
export const CreateAccessRuleDstOneOf1TypeEnum = {
    Tag: 'Tag'
} as const;
export type CreateAccessRuleDstOneOf1TypeEnum = typeof CreateAccessRuleDstOneOf1TypeEnum[keyof typeof CreateAccessRuleDstOneOf1TypeEnum];

/**
 * 
 * @export
 * @interface CreateAccessRuleDstOneOf2
 */
export interface CreateAccessRuleDstOneOf2 {
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRuleDstOneOf2
     */
    type: CreateAccessRuleDstOneOf2TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRuleDstOneOf2
     */
    value: string;
}


/**
 * @export
 */
export const CreateAccessRuleDstOneOf2TypeEnum = {
    Subnet: 'Subnet'
} as const;
export type CreateAccessRuleDstOneOf2TypeEnum = typeof CreateAccessRuleDstOneOf2TypeEnum[keyof typeof CreateAccessRuleDstOneOf2TypeEnum];

/**
 * @type CreateAccessRulePort
 * 
 * @export
 */
export type CreateAccessRulePort = CreateAccessRulePortOneOf | CreateAccessRulePortOneOf1 | CreateAccessRulePortOneOf2;
/**
 * 
 * @export
 * @interface CreateAccessRulePortOneOf
 */
export interface CreateAccessRulePortOneOf {
    /**
     * 
     * @type {number}
     * @memberof CreateAccessRulePortOneOf
     */
    port: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRulePortOneOf
     */
    type: CreateAccessRulePortOneOfTypeEnum;
}


/**
 * @export
 */
export const CreateAccessRulePortOneOfTypeEnum = {
    Single: 'Single'
} as const;
export type CreateAccessRulePortOneOfTypeEnum = typeof CreateAccessRulePortOneOfTypeEnum[keyof typeof CreateAccessRulePortOneOfTypeEnum];

/**
 * 
 * @export
 * @interface CreateAccessRulePortOneOf1
 */
export interface CreateAccessRulePortOneOf1 {
    /**
     * 
     * @type {number}
     * @memberof CreateAccessRulePortOneOf1
     */
    end: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAccessRulePortOneOf1
     */
    start: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRulePortOneOf1
     */
    type: CreateAccessRulePortOneOf1TypeEnum;
}


/**
 * @export
 */
export const CreateAccessRulePortOneOf1TypeEnum = {
    Range: 'Range'
} as const;
export type CreateAccessRulePortOneOf1TypeEnum = typeof CreateAccessRulePortOneOf1TypeEnum[keyof typeof CreateAccessRulePortOneOf1TypeEnum];

/**
 * 
 * @export
 * @interface CreateAccessRulePortOneOf2
 */
export interface CreateAccessRulePortOneOf2 {
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRulePortOneOf2
     */
    type: CreateAccessRulePortOneOf2TypeEnum;
}


/**
 * @export
 */
export const CreateAccessRulePortOneOf2TypeEnum = {
    Any: 'Any'
} as const;
export type CreateAccessRulePortOneOf2TypeEnum = typeof CreateAccessRulePortOneOf2TypeEnum[keyof typeof CreateAccessRulePortOneOf2TypeEnum];

/**
 * 
 * @export
 * @interface CreateAccessRuleRequest
 */
export interface CreateAccessRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAccessRuleRequest
     */
    description: string;
    /**
     * 
     * @type {CreateAccessRuleDst}
     * @memberof CreateAccessRuleRequest
     */
    dst: CreateAccessRuleDst;
    /**
     * 
     * @type {CreateAccessRulePort}
     * @memberof CreateAccessRuleRequest
     */
    port: CreateAccessRulePort;
    /**
     * 
     * @type {AccessRuleProtocol}
     * @memberof CreateAccessRuleRequest
     */
    protocol: AccessRuleProtocol;
    /**
     * 
     * @type {CreateAccessRuleSrc}
     * @memberof CreateAccessRuleRequest
     */
    src: CreateAccessRuleSrc;
}
/**
 * @type CreateAccessRuleSrc
 * 
 * @export
 */
export type CreateAccessRuleSrc = CreateAccessRuleDstOneOf | CreateAccessRuleDstOneOf1 | CreateAccessRuleDstOneOf2;
/**
 * 
 * @export
 * @interface CreateLocalGroupErrors
 */
export interface CreateLocalGroupErrors {
    /**
     * The name is not unique
     * @type {boolean}
     * @memberof CreateLocalGroupErrors
     */
    name: boolean;
}
/**
 * 
 * @export
 * @interface CreateLocalGroupRequest
 */
export interface CreateLocalGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLocalGroupRequest
     */
    description: string;
    /**
     * Allows this group to have access to `autogroup:internet`
     * @type {boolean}
     * @memberof CreateLocalGroupRequest
     */
    internet: boolean;
    /**
     * The group's name
     * 
     * Must be unique among all local groups
     * @type {string}
     * @memberof CreateLocalGroupRequest
     */
    name: string;
}
/**
 * 
 * @export
 * @interface CreatePreAuthKeyRequest
 */
export interface CreatePreAuthKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePreAuthKeyRequest
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePreAuthKeyRequest
     */
    ephemeral: boolean;
    /**
     * Number of days until the key expires
     * @type {number}
     * @memberof CreatePreAuthKeyRequest
     */
    expiration?: number | null;
    /**
     * Can the key be used more than once?
     * @type {boolean}
     * @memberof CreatePreAuthKeyRequest
     */
    reusable: boolean;
    /**
     * List of tags to apply to the device which will use this key
     * 
     * It is a list of uuids.
     * 
     * Each uuid must appear at most once.
     * @type {Array<string>}
     * @memberof CreatePreAuthKeyRequest
     */
    tags: Array<string>;
}
/**
 * 
 * @export
 * @interface CreatePreAuthKeyResponse
 */
export interface CreatePreAuthKeyResponse {
    /**
     * The key's value
     * @type {string}
     * @memberof CreatePreAuthKeyResponse
     */
    key: string;
    /**
     * The key's uuid
     * @type {string}
     * @memberof CreatePreAuthKeyResponse
     */
    uuid: string;
}
/**
 * Error response for creating a new Split Dns Domain
 * @export
 * @interface CreateSplitDnsDomainError
 */
export interface CreateSplitDnsDomainError {
    /**
     * The domain name is already in use
     * @type {boolean}
     * @memberof CreateSplitDnsDomainError
     */
    domain_already_exists: boolean;
    /**
     * The name of the domain which is not a valid domain
     * @type {boolean}
     * @memberof CreateSplitDnsDomainError
     */
    domain_invalid: boolean;
}
/**
 * Request for creating a new Split Dns Domain
 * @export
 * @interface CreateSplitDnsDomainRequest
 */
export interface CreateSplitDnsDomainRequest {
    /**
     * Marks whether this Split Dns configuration is actively used or not
     * @type {boolean}
     * @memberof CreateSplitDnsDomainRequest
     */
    disabled: boolean;
    /**
     * The domain name
     * @type {string}
     * @memberof CreateSplitDnsDomainRequest
     */
    domain: string;
}
/**
 * Errors for creating a new split dns resolver
 * @export
 * @interface CreateSplitDnsResolverErrors
 */
export interface CreateSplitDnsResolverErrors {
    /**
     * Ip address is already in use in this domain
     * @type {boolean}
     * @memberof CreateSplitDnsResolverErrors
     */
    ip_already_exists: boolean;
    /**
     * Ip address is not a valid ip address
     * @type {boolean}
     * @memberof CreateSplitDnsResolverErrors
     */
    ip_invalid: boolean;
}
/**
 * Request for creating a new split dns resolver
 * @export
 * @interface CreateSplitDnsResolverRequest
 */
export interface CreateSplitDnsResolverRequest {
    /**
     * Better description to identify the resolver
     * @type {string}
     * @memberof CreateSplitDnsResolverRequest
     */
    description: string;
    /**
     * Marks whether this resolver is actively used or not
     * @type {boolean}
     * @memberof CreateSplitDnsResolverRequest
     */
    disabled: boolean;
    /**
     * The IP of the resolver
     * @type {string}
     * @memberof CreateSplitDnsResolverRequest
     */
    ip: string;
}
/**
 * 
 * @export
 * @interface CreateTagErrors
 */
export interface CreateTagErrors {
    /**
     * The tag's name already exists
     * @type {boolean}
     * @memberof CreateTagErrors
     */
    name_not_unique: boolean;
}
/**
 * 
 * @export
 * @interface CreateTagRequest
 */
export interface CreateTagRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTagRequest
     */
    description: string;
    /**
     * The tag's name (**without** the "tag:" prefix)
     * @type {string}
     * @memberof CreateTagRequest
     */
    name: string;
}
/**
 * 
 * @export
 * @interface DeleteLocalGroupErrors
 */
export interface DeleteLocalGroupErrors {
    /**
     * Number of access rules which still use this group
     * @type {number}
     * @memberof DeleteLocalGroupErrors
     */
    access_rules?: number | null;
}
/**
 * 
 * @export
 * @interface DeleteTagErrors
 */
export interface DeleteTagErrors {
    /**
     * Number of access rules which still use this tag
     * @type {number}
     * @memberof DeleteTagErrors
     */
    access_rules?: number | null;
    /**
     * Number of devices which still use this tag
     * @type {number}
     * @memberof DeleteTagErrors
     */
    devices?: number | null;
    /**
     * Number of pre-auth keys which still require this tag
     * @type {number}
     * @memberof DeleteTagErrors
     */
    preauthkeys?: number | null;
}
/**
 * 
 * @export
 * @interface DeviceFromIpResponse
 */
export interface DeviceFromIpResponse {
    /**
     * Name of the Device
     * @type {string}
     * @memberof DeviceFromIpResponse
     */
    name: string;
    /**
     * Uuid of the Device
     * @type {string}
     * @memberof DeviceFromIpResponse
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface EnableSubnetErrors
 */
export interface EnableSubnetErrors {
    /**
     * The subnet has multiple possible routers (or none)
     * @type {Array<FullSubnetRouter>}
     * @memberof EnableSubnetErrors
     */
    routers?: Array<FullSubnetRouter> | null;
}
/**
 * 
 * @export
 * @interface EnableSubnetRequest
 */
export interface EnableSubnetRequest {
    /**
     * Uuid of the device to use as router.
     * 
     * If only one device advocates being the router, then this field can be left empty.
     * @type {string}
     * @memberof EnableSubnetRequest
     */
    router?: string | null;
}
/**
 * Represent a device, with only relevant parameters for the exit node
 * @export
 * @interface ExitNodeDevice
 */
export interface ExitNodeDevice {
    /**
     * When the device was created
     * @type {string}
     * @memberof ExitNodeDevice
     */
    created_at: string;
    /**
     * Name this device is named in the dns
     * 
     * This value is inferred from `hostname` but can be overwritten by an admin.
     * @type {string}
     * @memberof ExitNodeDevice
     */
    dnsname: string;
    /**
     * Has the device' session expired?
     * @type {boolean}
     * @memberof ExitNodeDevice
     */
    expired: boolean;
    /**
     * When will the device's current session expire?
     * @type {string}
     * @memberof ExitNodeDevice
     */
    expiry?: string | null;
    /**
     * Hostname set by the tailscale client
     * 
     * This value is not used for the DNS.
     * @type {string}
     * @memberof ExitNodeDevice
     */
    hostname: string;
    /**
     * Ip v4 addresses
     * @type {string}
     * @memberof ExitNodeDevice
     */
    ipv4?: string | null;
    /**
     * Ip v6 addresses
     * @type {string}
     * @memberof ExitNodeDevice
     */
    ipv6?: string | null;
    /**
     * When was the time the device was online?
     * @type {string}
     * @memberof ExitNodeDevice
     */
    last_seen?: string | null;
    /**
     * Is the device currently online?
     * @type {boolean}
     * @memberof ExitNodeDevice
     */
    online: boolean;
    /**
     * The device's tags
     * @type {Array<SimpleTag>}
     * @memberof ExitNodeDevice
     */
    tags: Array<SimpleTag>;
    /**
     * The primary key
     * @type {string}
     * @memberof ExitNodeDevice
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface ExtraDnsRecordError
 */
export interface ExtraDnsRecordError {
    /**
     * The IP address was already added to the Domain
     * @type {boolean}
     * @memberof ExtraDnsRecordError
     */
    ip_address_exists: boolean;
    /**
     * The ip of the record is not a valid ip
     * @type {boolean}
     * @memberof ExtraDnsRecordError
     */
    ip_invalid: boolean;
    /**
     * If the IP is in the internal range but no device exists
     * @type {boolean}
     * @memberof ExtraDnsRecordError
     */
    no_internal_device: boolean;
}

/**
 * 
 * @export
 */
export const ExtraDnsRecordType = {
    A: 'A',
    AAAA: 'AAAA'
} as const;
export type ExtraDnsRecordType = typeof ExtraDnsRecordType[keyof typeof ExtraDnsRecordType];

/**
 * @type FormResultForNullAndAddExtraDnsError
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndAddExtraDnsError = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndAddExtraDnsErrorOneOf1;
/**
 * 
 * @export
 * @interface FormResultForNullAndAddExtraDnsErrorOneOf
 */
export interface FormResultForNullAndAddExtraDnsErrorOneOf {
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndAddExtraDnsErrorOneOf
     */
    result: FormResultForNullAndAddExtraDnsErrorOneOfResultEnum;
    /**
     * 
     * @type {any}
     * @memberof FormResultForNullAndAddExtraDnsErrorOneOf
     */
    value: any | null;
}


/**
 * @export
 */
export const FormResultForNullAndAddExtraDnsErrorOneOfResultEnum = {
    Ok: 'Ok'
} as const;
export type FormResultForNullAndAddExtraDnsErrorOneOfResultEnum = typeof FormResultForNullAndAddExtraDnsErrorOneOfResultEnum[keyof typeof FormResultForNullAndAddExtraDnsErrorOneOfResultEnum];

/**
 * 
 * @export
 * @interface FormResultForNullAndAddExtraDnsErrorOneOf1
 */
export interface FormResultForNullAndAddExtraDnsErrorOneOf1 {
    /**
     * 
     * @type {AddExtraDnsError}
     * @memberof FormResultForNullAndAddExtraDnsErrorOneOf1
     */
    error: AddExtraDnsError;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndAddExtraDnsErrorOneOf1
     */
    result: FormResultForNullAndAddExtraDnsErrorOneOf1ResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndAddExtraDnsErrorOneOf1ResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndAddExtraDnsErrorOneOf1ResultEnum = typeof FormResultForNullAndAddExtraDnsErrorOneOf1ResultEnum[keyof typeof FormResultForNullAndAddExtraDnsErrorOneOf1ResultEnum];

/**
 * @type FormResultForNullAndAddMemberToLocalGroupError
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndAddMemberToLocalGroupError = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndAddMemberToLocalGroupErrorOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndAddMemberToLocalGroupErrorOneOf
 */
export interface FormResultForNullAndAddMemberToLocalGroupErrorOneOf {
    /**
     * 
     * @type {AddMemberToLocalGroupError}
     * @memberof FormResultForNullAndAddMemberToLocalGroupErrorOneOf
     */
    error: AddMemberToLocalGroupError;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndAddMemberToLocalGroupErrorOneOf
     */
    result: FormResultForNullAndAddMemberToLocalGroupErrorOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndAddMemberToLocalGroupErrorOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndAddMemberToLocalGroupErrorOneOfResultEnum = typeof FormResultForNullAndAddMemberToLocalGroupErrorOneOfResultEnum[keyof typeof FormResultForNullAndAddMemberToLocalGroupErrorOneOfResultEnum];

/**
 * @type FormResultForNullAndCreateSplitDnsDomainError
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndCreateSplitDnsDomainError = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndCreateSplitDnsDomainErrorOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndCreateSplitDnsDomainErrorOneOf
 */
export interface FormResultForNullAndCreateSplitDnsDomainErrorOneOf {
    /**
     * 
     * @type {CreateSplitDnsDomainError}
     * @memberof FormResultForNullAndCreateSplitDnsDomainErrorOneOf
     */
    error: CreateSplitDnsDomainError;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndCreateSplitDnsDomainErrorOneOf
     */
    result: FormResultForNullAndCreateSplitDnsDomainErrorOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndCreateSplitDnsDomainErrorOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndCreateSplitDnsDomainErrorOneOfResultEnum = typeof FormResultForNullAndCreateSplitDnsDomainErrorOneOfResultEnum[keyof typeof FormResultForNullAndCreateSplitDnsDomainErrorOneOfResultEnum];

/**
 * @type FormResultForNullAndCreateSplitDnsResolverErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndCreateSplitDnsResolverErrors = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndCreateSplitDnsResolverErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndCreateSplitDnsResolverErrorsOneOf
 */
export interface FormResultForNullAndCreateSplitDnsResolverErrorsOneOf {
    /**
     * 
     * @type {CreateSplitDnsResolverErrors}
     * @memberof FormResultForNullAndCreateSplitDnsResolverErrorsOneOf
     */
    error: CreateSplitDnsResolverErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndCreateSplitDnsResolverErrorsOneOf
     */
    result: FormResultForNullAndCreateSplitDnsResolverErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndCreateSplitDnsResolverErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndCreateSplitDnsResolverErrorsOneOfResultEnum = typeof FormResultForNullAndCreateSplitDnsResolverErrorsOneOfResultEnum[keyof typeof FormResultForNullAndCreateSplitDnsResolverErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndDeleteLocalGroupErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndDeleteLocalGroupErrors = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndDeleteLocalGroupErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndDeleteLocalGroupErrorsOneOf
 */
export interface FormResultForNullAndDeleteLocalGroupErrorsOneOf {
    /**
     * 
     * @type {DeleteLocalGroupErrors}
     * @memberof FormResultForNullAndDeleteLocalGroupErrorsOneOf
     */
    error: DeleteLocalGroupErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndDeleteLocalGroupErrorsOneOf
     */
    result: FormResultForNullAndDeleteLocalGroupErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndDeleteLocalGroupErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndDeleteLocalGroupErrorsOneOfResultEnum = typeof FormResultForNullAndDeleteLocalGroupErrorsOneOfResultEnum[keyof typeof FormResultForNullAndDeleteLocalGroupErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndDeleteTagErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndDeleteTagErrors = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndDeleteTagErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndDeleteTagErrorsOneOf
 */
export interface FormResultForNullAndDeleteTagErrorsOneOf {
    /**
     * 
     * @type {DeleteTagErrors}
     * @memberof FormResultForNullAndDeleteTagErrorsOneOf
     */
    error: DeleteTagErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndDeleteTagErrorsOneOf
     */
    result: FormResultForNullAndDeleteTagErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndDeleteTagErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndDeleteTagErrorsOneOfResultEnum = typeof FormResultForNullAndDeleteTagErrorsOneOfResultEnum[keyof typeof FormResultForNullAndDeleteTagErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndEnableSubnetErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndEnableSubnetErrors = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndEnableSubnetErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndEnableSubnetErrorsOneOf
 */
export interface FormResultForNullAndEnableSubnetErrorsOneOf {
    /**
     * 
     * @type {EnableSubnetErrors}
     * @memberof FormResultForNullAndEnableSubnetErrorsOneOf
     */
    error: EnableSubnetErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndEnableSubnetErrorsOneOf
     */
    result: FormResultForNullAndEnableSubnetErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndEnableSubnetErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndEnableSubnetErrorsOneOfResultEnum = typeof FormResultForNullAndEnableSubnetErrorsOneOfResultEnum[keyof typeof FormResultForNullAndEnableSubnetErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndExtraDnsRecordError
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndExtraDnsRecordError = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndExtraDnsRecordErrorOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndExtraDnsRecordErrorOneOf
 */
export interface FormResultForNullAndExtraDnsRecordErrorOneOf {
    /**
     * 
     * @type {ExtraDnsRecordError}
     * @memberof FormResultForNullAndExtraDnsRecordErrorOneOf
     */
    error: ExtraDnsRecordError;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndExtraDnsRecordErrorOneOf
     */
    result: FormResultForNullAndExtraDnsRecordErrorOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndExtraDnsRecordErrorOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndExtraDnsRecordErrorOneOfResultEnum = typeof FormResultForNullAndExtraDnsRecordErrorOneOfResultEnum[keyof typeof FormResultForNullAndExtraDnsRecordErrorOneOfResultEnum];

/**
 * @type FormResultForNullAndSetDeviceDnsnameErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndSetDeviceDnsnameErrors = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndSetDeviceDnsnameErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndSetDeviceDnsnameErrorsOneOf
 */
export interface FormResultForNullAndSetDeviceDnsnameErrorsOneOf {
    /**
     * 
     * @type {SetDeviceDnsnameErrors}
     * @memberof FormResultForNullAndSetDeviceDnsnameErrorsOneOf
     */
    error: SetDeviceDnsnameErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndSetDeviceDnsnameErrorsOneOf
     */
    result: FormResultForNullAndSetDeviceDnsnameErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndSetDeviceDnsnameErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndSetDeviceDnsnameErrorsOneOfResultEnum = typeof FormResultForNullAndSetDeviceDnsnameErrorsOneOfResultEnum[keyof typeof FormResultForNullAndSetDeviceDnsnameErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndSetGeneralSettingsErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndSetGeneralSettingsErrors = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndSetGeneralSettingsErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndSetGeneralSettingsErrorsOneOf
 */
export interface FormResultForNullAndSetGeneralSettingsErrorsOneOf {
    /**
     * 
     * @type {SetGeneralSettingsErrors}
     * @memberof FormResultForNullAndSetGeneralSettingsErrorsOneOf
     */
    error: SetGeneralSettingsErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndSetGeneralSettingsErrorsOneOf
     */
    result: FormResultForNullAndSetGeneralSettingsErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndSetGeneralSettingsErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndSetGeneralSettingsErrorsOneOfResultEnum = typeof FormResultForNullAndSetGeneralSettingsErrorsOneOfResultEnum[keyof typeof FormResultForNullAndSetGeneralSettingsErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndSetLdapConnectionSettingsErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndSetLdapConnectionSettingsErrors = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndSetLdapConnectionSettingsErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndSetLdapConnectionSettingsErrorsOneOf
 */
export interface FormResultForNullAndSetLdapConnectionSettingsErrorsOneOf {
    /**
     * 
     * @type {SetLdapConnectionSettingsErrors}
     * @memberof FormResultForNullAndSetLdapConnectionSettingsErrorsOneOf
     */
    error: SetLdapConnectionSettingsErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndSetLdapConnectionSettingsErrorsOneOf
     */
    result: FormResultForNullAndSetLdapConnectionSettingsErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndSetLdapConnectionSettingsErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndSetLdapConnectionSettingsErrorsOneOfResultEnum = typeof FormResultForNullAndSetLdapConnectionSettingsErrorsOneOfResultEnum[keyof typeof FormResultForNullAndSetLdapConnectionSettingsErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndSetLdapSettingsErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndSetLdapSettingsErrors = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndSetLdapSettingsErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndSetLdapSettingsErrorsOneOf
 */
export interface FormResultForNullAndSetLdapSettingsErrorsOneOf {
    /**
     * 
     * @type {SetLdapSettingsErrors}
     * @memberof FormResultForNullAndSetLdapSettingsErrorsOneOf
     */
    error: SetLdapSettingsErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndSetLdapSettingsErrorsOneOf
     */
    result: FormResultForNullAndSetLdapSettingsErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndSetLdapSettingsErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndSetLdapSettingsErrorsOneOfResultEnum = typeof FormResultForNullAndSetLdapSettingsErrorsOneOfResultEnum[keyof typeof FormResultForNullAndSetLdapSettingsErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndSetTagNameErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndSetTagNameErrors = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndSetTagNameErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndSetTagNameErrorsOneOf
 */
export interface FormResultForNullAndSetTagNameErrorsOneOf {
    /**
     * 
     * @type {SetTagNameErrors}
     * @memberof FormResultForNullAndSetTagNameErrorsOneOf
     */
    error: SetTagNameErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndSetTagNameErrorsOneOf
     */
    result: FormResultForNullAndSetTagNameErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndSetTagNameErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndSetTagNameErrorsOneOfResultEnum = typeof FormResultForNullAndSetTagNameErrorsOneOfResultEnum[keyof typeof FormResultForNullAndSetTagNameErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndUpdateExtraDnsDomainError
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndUpdateExtraDnsDomainError = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndUpdateExtraDnsDomainErrorOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndUpdateExtraDnsDomainErrorOneOf
 */
export interface FormResultForNullAndUpdateExtraDnsDomainErrorOneOf {
    /**
     * 
     * @type {UpdateExtraDnsDomainError}
     * @memberof FormResultForNullAndUpdateExtraDnsDomainErrorOneOf
     */
    error: UpdateExtraDnsDomainError;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndUpdateExtraDnsDomainErrorOneOf
     */
    result: FormResultForNullAndUpdateExtraDnsDomainErrorOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndUpdateExtraDnsDomainErrorOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndUpdateExtraDnsDomainErrorOneOfResultEnum = typeof FormResultForNullAndUpdateExtraDnsDomainErrorOneOfResultEnum[keyof typeof FormResultForNullAndUpdateExtraDnsDomainErrorOneOfResultEnum];

/**
 * @type FormResultForNullAndUpdateExtraDnsRecordError
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndUpdateExtraDnsRecordError = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndUpdateExtraDnsRecordErrorOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndUpdateExtraDnsRecordErrorOneOf
 */
export interface FormResultForNullAndUpdateExtraDnsRecordErrorOneOf {
    /**
     * 
     * @type {UpdateExtraDnsRecordError}
     * @memberof FormResultForNullAndUpdateExtraDnsRecordErrorOneOf
     */
    error: UpdateExtraDnsRecordError;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndUpdateExtraDnsRecordErrorOneOf
     */
    result: FormResultForNullAndUpdateExtraDnsRecordErrorOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndUpdateExtraDnsRecordErrorOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndUpdateExtraDnsRecordErrorOneOfResultEnum = typeof FormResultForNullAndUpdateExtraDnsRecordErrorOneOfResultEnum[keyof typeof FormResultForNullAndUpdateExtraDnsRecordErrorOneOfResultEnum];

/**
 * @type FormResultForNullAndUpdateGlobalDnsErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndUpdateGlobalDnsErrors = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndUpdateGlobalDnsErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndUpdateGlobalDnsErrorsOneOf
 */
export interface FormResultForNullAndUpdateGlobalDnsErrorsOneOf {
    /**
     * 
     * @type {UpdateGlobalDnsErrors}
     * @memberof FormResultForNullAndUpdateGlobalDnsErrorsOneOf
     */
    error: UpdateGlobalDnsErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndUpdateGlobalDnsErrorsOneOf
     */
    result: FormResultForNullAndUpdateGlobalDnsErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndUpdateGlobalDnsErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndUpdateGlobalDnsErrorsOneOfResultEnum = typeof FormResultForNullAndUpdateGlobalDnsErrorsOneOfResultEnum[keyof typeof FormResultForNullAndUpdateGlobalDnsErrorsOneOfResultEnum];

/**
 * @type FormResultForNullAndUpdateSplitDnsDomainError
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndUpdateSplitDnsDomainError = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndUpdateSplitDnsDomainErrorOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndUpdateSplitDnsDomainErrorOneOf
 */
export interface FormResultForNullAndUpdateSplitDnsDomainErrorOneOf {
    /**
     * 
     * @type {UpdateSplitDnsDomainError}
     * @memberof FormResultForNullAndUpdateSplitDnsDomainErrorOneOf
     */
    error: UpdateSplitDnsDomainError;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndUpdateSplitDnsDomainErrorOneOf
     */
    result: FormResultForNullAndUpdateSplitDnsDomainErrorOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndUpdateSplitDnsDomainErrorOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndUpdateSplitDnsDomainErrorOneOfResultEnum = typeof FormResultForNullAndUpdateSplitDnsDomainErrorOneOfResultEnum[keyof typeof FormResultForNullAndUpdateSplitDnsDomainErrorOneOfResultEnum];

/**
 * @type FormResultForNullAndUpdateSplitDnsResolverErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForNullAndUpdateSplitDnsResolverErrors = FormResultForNullAndAddExtraDnsErrorOneOf | FormResultForNullAndUpdateSplitDnsResolverErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForNullAndUpdateSplitDnsResolverErrorsOneOf
 */
export interface FormResultForNullAndUpdateSplitDnsResolverErrorsOneOf {
    /**
     * 
     * @type {UpdateSplitDnsResolverErrors}
     * @memberof FormResultForNullAndUpdateSplitDnsResolverErrorsOneOf
     */
    error: UpdateSplitDnsResolverErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForNullAndUpdateSplitDnsResolverErrorsOneOf
     */
    result: FormResultForNullAndUpdateSplitDnsResolverErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForNullAndUpdateSplitDnsResolverErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForNullAndUpdateSplitDnsResolverErrorsOneOfResultEnum = typeof FormResultForNullAndUpdateSplitDnsResolverErrorsOneOfResultEnum[keyof typeof FormResultForNullAndUpdateSplitDnsResolverErrorsOneOfResultEnum];

/**
 * @type FormResultForSingleUuidAndCreateLocalGroupErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForSingleUuidAndCreateLocalGroupErrors = FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf | FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf1;
/**
 * 
 * @export
 * @interface FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf
 */
export interface FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf {
    /**
     * 
     * @type {string}
     * @memberof FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf
     */
    result: FormResultForSingleUuidAndCreateLocalGroupErrorsOneOfResultEnum;
    /**
     * 
     * @type {SingleUuid}
     * @memberof FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf
     */
    value: SingleUuid;
}


/**
 * @export
 */
export const FormResultForSingleUuidAndCreateLocalGroupErrorsOneOfResultEnum = {
    Ok: 'Ok'
} as const;
export type FormResultForSingleUuidAndCreateLocalGroupErrorsOneOfResultEnum = typeof FormResultForSingleUuidAndCreateLocalGroupErrorsOneOfResultEnum[keyof typeof FormResultForSingleUuidAndCreateLocalGroupErrorsOneOfResultEnum];

/**
 * 
 * @export
 * @interface FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf1
 */
export interface FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf1 {
    /**
     * 
     * @type {CreateLocalGroupErrors}
     * @memberof FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf1
     */
    error: CreateLocalGroupErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf1
     */
    result: FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf1ResultEnum;
}


/**
 * @export
 */
export const FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf1ResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf1ResultEnum = typeof FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf1ResultEnum[keyof typeof FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf1ResultEnum];

/**
 * @type FormResultForSingleUuidAndCreateTagErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForSingleUuidAndCreateTagErrors = FormResultForSingleUuidAndCreateLocalGroupErrorsOneOf | FormResultForSingleUuidAndCreateTagErrorsOneOf;
/**
 * 
 * @export
 * @interface FormResultForSingleUuidAndCreateTagErrorsOneOf
 */
export interface FormResultForSingleUuidAndCreateTagErrorsOneOf {
    /**
     * 
     * @type {CreateTagErrors}
     * @memberof FormResultForSingleUuidAndCreateTagErrorsOneOf
     */
    error: CreateTagErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForSingleUuidAndCreateTagErrorsOneOf
     */
    result: FormResultForSingleUuidAndCreateTagErrorsOneOfResultEnum;
}


/**
 * @export
 */
export const FormResultForSingleUuidAndCreateTagErrorsOneOfResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForSingleUuidAndCreateTagErrorsOneOfResultEnum = typeof FormResultForSingleUuidAndCreateTagErrorsOneOfResultEnum[keyof typeof FormResultForSingleUuidAndCreateTagErrorsOneOfResultEnum];

/**
 * @type FormResultForTestLdapSearchResponseAndTestLdapSettingsErrors
 * A `Result` with a custom serialization
 * @export
 */
export type FormResultForTestLdapSearchResponseAndTestLdapSettingsErrors = FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf | FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1;
/**
 * 
 * @export
 * @interface FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf
 */
export interface FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf {
    /**
     * 
     * @type {string}
     * @memberof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf
     */
    result: FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOfResultEnum;
    /**
     * 
     * @type {TestLdapSearchResponse}
     * @memberof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf
     */
    value: TestLdapSearchResponse;
}


/**
 * @export
 */
export const FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOfResultEnum = {
    Ok: 'Ok'
} as const;
export type FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOfResultEnum = typeof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOfResultEnum[keyof typeof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOfResultEnum];

/**
 * 
 * @export
 * @interface FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1
 */
export interface FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1 {
    /**
     * 
     * @type {TestLdapSettingsErrors}
     * @memberof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1
     */
    error: TestLdapSettingsErrors;
    /**
     * 
     * @type {string}
     * @memberof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1
     */
    result: FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1ResultEnum;
}


/**
 * @export
 */
export const FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1ResultEnum = {
    Err: 'Err'
} as const;
export type FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1ResultEnum = typeof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1ResultEnum[keyof typeof FormResultForTestLdapSearchResponseAndTestLdapSettingsErrorsOneOf1ResultEnum];

/**
 * 
 * @export
 * @interface FullAccessRule
 */
export interface FullAccessRule {
    /**
     * 
     * @type {string}
     * @memberof FullAccessRule
     */
    description: string;
    /**
     * 
     * @type {FullAccessRuleDst}
     * @memberof FullAccessRule
     */
    dst: FullAccessRuleDst;
    /**
     * 
     * @type {number}
     * @memberof FullAccessRule
     */
    port: number;
    /**
     * 
     * @type {number}
     * @memberof FullAccessRule
     */
    port_range_end?: number | null;
    /**
     * 
     * @type {AccessRuleProtocol}
     * @memberof FullAccessRule
     */
    protocol: AccessRuleProtocol;
    /**
     * 
     * @type {FullAccessRuleSrc}
     * @memberof FullAccessRule
     */
    src: FullAccessRuleSrc;
    /**
     * 
     * @type {string}
     * @memberof FullAccessRule
     */
    uuid: string;
}
/**
 * @type FullAccessRuleDst
 * 
 * @export
 */
export type FullAccessRuleDst = FullAccessRuleDstOneOf | FullAccessRuleDstOneOf1 | FullAccessRuleDstOneOf2;
/**
 * 
 * @export
 * @interface FullAccessRuleDstOneOf
 */
export interface FullAccessRuleDstOneOf {
    /**
     * 
     * @type {string}
     * @memberof FullAccessRuleDstOneOf
     */
    type: FullAccessRuleDstOneOfTypeEnum;
    /**
     * 
     * @type {SimpleGroup}
     * @memberof FullAccessRuleDstOneOf
     */
    value: SimpleGroup;
}


/**
 * @export
 */
export const FullAccessRuleDstOneOfTypeEnum = {
    Group: 'Group'
} as const;
export type FullAccessRuleDstOneOfTypeEnum = typeof FullAccessRuleDstOneOfTypeEnum[keyof typeof FullAccessRuleDstOneOfTypeEnum];

/**
 * 
 * @export
 * @interface FullAccessRuleDstOneOf1
 */
export interface FullAccessRuleDstOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof FullAccessRuleDstOneOf1
     */
    type: FullAccessRuleDstOneOf1TypeEnum;
    /**
     * 
     * @type {SimpleTag}
     * @memberof FullAccessRuleDstOneOf1
     */
    value: SimpleTag;
}


/**
 * @export
 */
export const FullAccessRuleDstOneOf1TypeEnum = {
    Tag: 'Tag'
} as const;
export type FullAccessRuleDstOneOf1TypeEnum = typeof FullAccessRuleDstOneOf1TypeEnum[keyof typeof FullAccessRuleDstOneOf1TypeEnum];

/**
 * 
 * @export
 * @interface FullAccessRuleDstOneOf2
 */
export interface FullAccessRuleDstOneOf2 {
    /**
     * 
     * @type {string}
     * @memberof FullAccessRuleDstOneOf2
     */
    type: FullAccessRuleDstOneOf2TypeEnum;
    /**
     * 
     * @type {SimpleSubnet}
     * @memberof FullAccessRuleDstOneOf2
     */
    value: SimpleSubnet;
}


/**
 * @export
 */
export const FullAccessRuleDstOneOf2TypeEnum = {
    Subnet: 'Subnet'
} as const;
export type FullAccessRuleDstOneOf2TypeEnum = typeof FullAccessRuleDstOneOf2TypeEnum[keyof typeof FullAccessRuleDstOneOf2TypeEnum];

/**
 * @type FullAccessRuleSrc
 * 
 * @export
 */
export type FullAccessRuleSrc = FullAccessRuleDstOneOf | FullAccessRuleDstOneOf1 | FullAccessRuleDstOneOf2;
/**
 * 
 * @export
 * @interface FullDevice
 */
export interface FullDevice {
    /**
     * When was the device created?
     * @type {string}
     * @memberof FullDevice
     */
    created_at: string;
    /**
     * Name this device is named in the dns
     * 
     * This value is inferred from `hostname` but can be overwritten by an admin.
     * @type {string}
     * @memberof FullDevice
     */
    dnsname: string;
    /**
     * Has the device' session expired?
     * @type {boolean}
     * @memberof FullDevice
     */
    expired: boolean;
    /**
     * When will the device's current session expire?
     * @type {string}
     * @memberof FullDevice
     */
    expiry?: string | null;
    /**
     * The extra records for this device
     * @type {Array<SimpleExtraDnsDomain>}
     * @memberof FullDevice
     */
    extra_records: Array<SimpleExtraDnsDomain>;
    /**
     * Hostname set by the tailscale client
     * 
     * This value is not used for the DNS.
     * @type {string}
     * @memberof FullDevice
     */
    hostname: string;
    /**
     * 
     * @type {string}
     * @memberof FullDevice
     */
    ipv4?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FullDevice
     */
    ipv6?: string | null;
    /**
     * When was the time the device was online?
     * @type {string}
     * @memberof FullDevice
     */
    last_seen?: string | null;
    /**
     * Is the device currently online?
     * @type {boolean}
     * @memberof FullDevice
     */
    online: boolean;
    /**
     * The device's tags **if** the device is a server device
     * @type {Array<SimpleTag>}
     * @memberof FullDevice
     */
    tags?: Array<SimpleTag> | null;
    /**
     * The device's user **if** the device is a user device
     * @type {SimpleUser}
     * @memberof FullDevice
     */
    user?: SimpleUser | null;
    /**
     * The primary key
     * @type {string}
     * @memberof FullDevice
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullDeviceAccessRules
 */
export interface FullDeviceAccessRules {
    /**
     * 
     * @type {Array<FullDeviceAccessRulesGroup>}
     * @memberof FullDeviceAccessRules
     */
    groups: Array<FullDeviceAccessRulesGroup>;
    /**
     * 
     * @type {Array<FullDeviceAccessSubnet>}
     * @memberof FullDeviceAccessRules
     */
    subnets: Array<FullDeviceAccessSubnet>;
    /**
     * 
     * @type {Array<FullDeviceAccessRulesTag>}
     * @memberof FullDeviceAccessRules
     */
    tags: Array<FullDeviceAccessRulesTag>;
}
/**
 * 
 * @export
 * @interface FullDeviceAccessRulesGroup
 */
export interface FullDeviceAccessRulesGroup {
    /**
     * 
     * @type {Array<FullAccessRule>}
     * @memberof FullDeviceAccessRulesGroup
     */
    access_rules: Array<FullAccessRule>;
    /**
     * 
     * @type {string}
     * @memberof FullDeviceAccessRulesGroup
     */
    description: string;
    /**
     * The group's identifier in the synced source of truth
     * 
     * I.e. DN for LDAP syncs
     * @type {string}
     * @memberof FullDeviceAccessRulesGroup
     */
    external_id: string;
    /**
     * Allows this group to have access to `autogroup:internet`
     * @type {boolean}
     * @memberof FullDeviceAccessRulesGroup
     */
    internet: boolean;
    /**
     * The group's name (**without** the "group:" prefix)
     * @type {string}
     * @memberof FullDeviceAccessRulesGroup
     */
    name: string;
    /**
     * 
     * @type {GroupProvider}
     * @memberof FullDeviceAccessRulesGroup
     */
    provider: GroupProvider;
    /**
     * The group's uuid
     * @type {string}
     * @memberof FullDeviceAccessRulesGroup
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullDeviceAccessRulesTag
 */
export interface FullDeviceAccessRulesTag {
    /**
     * 
     * @type {Array<FullAccessRule>}
     * @memberof FullDeviceAccessRulesTag
     */
    access_rules: Array<FullAccessRule>;
    /**
     * 
     * @type {string}
     * @memberof FullDeviceAccessRulesTag
     */
    description: string;
    /**
     * A locked tag's access rules can't be edited
     * @type {boolean}
     * @memberof FullDeviceAccessRulesTag
     */
    locked: boolean;
    /**
     * The tag's name (**without** the "tag:" prefix)
     * @type {string}
     * @memberof FullDeviceAccessRulesTag
     */
    name: string;
    /**
     * Primary key
     * @type {string}
     * @memberof FullDeviceAccessRulesTag
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullDeviceAccessSubnet
 */
export interface FullDeviceAccessSubnet {
    /**
     * 
     * @type {Array<FullAccessRule>}
     * @memberof FullDeviceAccessSubnet
     */
    access_rules: Array<FullAccessRule>;
    /**
     * Description of the subnet
     * @type {string}
     * @memberof FullDeviceAccessSubnet
     */
    description: string;
    /**
     * Does this network have an associated device routing it?
     * @type {boolean}
     * @memberof FullDeviceAccessSubnet
     */
    has_router: boolean;
    /**
     * The network's prefix in CIDR
     * @type {string}
     * @memberof FullDeviceAccessSubnet
     */
    name: string;
    /**
     * Primary key
     * @type {string}
     * @memberof FullDeviceAccessSubnet
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullExtraDnsDomain
 */
export interface FullExtraDnsDomain {
    /**
     * Description
     * @type {string}
     * @memberof FullExtraDnsDomain
     */
    description: string;
    /**
     * The fully qualified domain name
     * @type {string}
     * @memberof FullExtraDnsDomain
     */
    from_dns: string;
    /**
     * BackRef to all records that belong to this domain
     * @type {Array<FullExtraDnsRecord>}
     * @memberof FullExtraDnsDomain
     */
    records: Array<FullExtraDnsRecord>;
    /**
     * The primary key
     * @type {string}
     * @memberof FullExtraDnsDomain
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullExtraDnsRecord
 */
export interface FullExtraDnsRecord {
    /**
     * Optional link to a known device (if to_ip matches device IP)
     * @type {string}
     * @memberof FullExtraDnsRecord
     */
    device_uuid?: string | null;
    /**
     * The DNS record type. Only A or AAAA. Other values are currently ignored.
     * @type {ExtraDnsRecordType}
     * @memberof FullExtraDnsRecord
     */
    record_type: ExtraDnsRecordType;
    /**
     * Target IP address for this record.
     * @type {string}
     * @memberof FullExtraDnsRecord
     */
    to_ip: string;
    /**
     * The primary key
     * @type {string}
     * @memberof FullExtraDnsRecord
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullGlobalDns
 */
export interface FullGlobalDns {
    /**
     * which type of DNS
     * 
     * e.g. "*google*", "*cloudflare*", "*quad9*" or "*custom*"
     * @type {GlobalDnsType}
     * @memberof FullGlobalDns
     */
    dns_type: GlobalDnsType;
    /**
     * 
     * @type {Array<string>}
     * @memberof FullGlobalDns
     */
    ipv4: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FullGlobalDns
     */
    ipv6: Array<string>;
}
/**
 * 
 * @export
 * @interface FullHeadscalePreAuthKey
 */
export interface FullHeadscalePreAuthKey {
    /**
     * 
     * @type {string}
     * @memberof FullHeadscalePreAuthKey
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof FullHeadscalePreAuthKey
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof FullHeadscalePreAuthKey
     */
    ephemeral: boolean;
    /**
     * 
     * @type {string}
     * @memberof FullHeadscalePreAuthKey
     */
    expiration?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FullHeadscalePreAuthKey
     */
    key: string;
    /**
     * 
     * @type {boolean}
     * @memberof FullHeadscalePreAuthKey
     */
    reusable: boolean;
    /**
     * 
     * @type {Array<SimpleTag>}
     * @memberof FullHeadscalePreAuthKey
     */
    tags: Array<SimpleTag>;
    /**
     * 
     * @type {boolean}
     * @memberof FullHeadscalePreAuthKey
     */
    used: boolean;
    /**
     * The key's uuid
     * @type {string}
     * @memberof FullHeadscalePreAuthKey
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullLdapSettings
 */
export interface FullLdapSettings {
    /**
     * The dn to search for groups
     * @type {string}
     * @memberof FullLdapSettings
     */
    group_base: string;
    /**
     * The filter to use when searching for groups
     * @type {string}
     * @memberof FullLdapSettings
     */
    group_filter: string;
    /**
     * LDAP attribute containing the group's name
     * @type {string}
     * @memberof FullLdapSettings
     */
    group_name: string;
    /**
     * Is the ldap sync enabled?
     * @type {boolean}
     * @memberof FullLdapSettings
     */
    ldap_enabled: boolean;
    /**
     * The password to authenticate with at ldap
     * @type {string}
     * @memberof FullLdapSettings
     */
    ldap_password: string;
    /**
     * The url under which the backend can reach the ldap
     * @type {string}
     * @memberof FullLdapSettings
     */
    ldap_url: string;
    /**
     * The username to authenticate with at ldap
     * @type {string}
     * @memberof FullLdapSettings
     */
    ldap_user: string;
    /**
     * LDAP attribute which stores the membership relation between groups and users
     * 
     * The flag `membership_in_group` stores whether this attribute is found on groups or users
     * @type {string}
     * @memberof FullLdapSettings
     */
    membership_attr: string;
    /**
     * Is the `membership_attr` set for groups and stores the list of users which are members of the group?
     * 
     * Alternatively, the `membership_attr` is set for users and stores the list of groups the user is member of.
     * @type {boolean}
     * @memberof FullLdapSettings
     */
    membership_in_group: boolean;
    /**
     * The dn to search for users
     * @type {string}
     * @memberof FullLdapSettings
     */
    user_base: string;
    /**
     * The filter to use when searching for users
     * @type {string}
     * @memberof FullLdapSettings
     */
    user_filter: string;
    /**
     * LDAP attribute containing the user's name
     * @type {string}
     * @memberof FullLdapSettings
     */
    user_name: string;
}
/**
 * 
 * @export
 * @interface FullSplitDnsDomain
 */
export interface FullSplitDnsDomain {
    /**
     * Marks whether this Split Dns configuration is actively used or not
     * @type {boolean}
     * @memberof FullSplitDnsDomain
     */
    disabled: boolean;
    /**
     * The domain name
     * @type {string}
     * @memberof FullSplitDnsDomain
     */
    domain: string;
    /**
     * List of all resolver
     * @type {Array<FullSplitDnsResolver>}
     * @memberof FullSplitDnsDomain
     */
    resolver: Array<FullSplitDnsResolver>;
    /**
     * The primary key
     * @type {string}
     * @memberof FullSplitDnsDomain
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullSplitDnsResolver
 */
export interface FullSplitDnsResolver {
    /**
     * Better description to identify the resolver
     * @type {string}
     * @memberof FullSplitDnsResolver
     */
    description: string;
    /**
     * Marks whether this resolver is actively used or not
     * @type {boolean}
     * @memberof FullSplitDnsResolver
     */
    disabled: boolean;
    /**
     * The IP of the resolver
     * @type {string}
     * @memberof FullSplitDnsResolver
     */
    ip: string;
    /**
     * The primary key
     * @type {string}
     * @memberof FullSplitDnsResolver
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullSubnet
 */
export interface FullSubnet {
    /**
     * 
     * @type {GetAllAccessRulesForResponse}
     * @memberof FullSubnet
     */
    access_rules: GetAllAccessRulesForResponse;
    /**
     * Description of the subnet
     * @type {string}
     * @memberof FullSubnet
     */
    description: string;
    /**
     * Does this network have an associated device routing it?
     * @type {boolean}
     * @memberof FullSubnet
     */
    has_router: boolean;
    /**
     * The network's prefix in CIDR
     * @type {string}
     * @memberof FullSubnet
     */
    name: string;
    /**
     * The device currently routing this network
     * @type {FullSubnetRouter}
     * @memberof FullSubnet
     */
    router?: FullSubnetRouter | null;
    /**
     * Primary key
     * @type {string}
     * @memberof FullSubnet
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullSubnetRouter
 */
export interface FullSubnetRouter {
    /**
     * When was the device created?
     * @type {string}
     * @memberof FullSubnetRouter
     */
    created_at: string;
    /**
     * Name this device is named in the dns
     * 
     * This value is inferred from `hostname` but can be overwritten by an admin.
     * @type {string}
     * @memberof FullSubnetRouter
     */
    dnsname: string;
    /**
     * Has the device' session expired?
     * @type {boolean}
     * @memberof FullSubnetRouter
     */
    expired: boolean;
    /**
     * When will the device's current session expire?
     * @type {string}
     * @memberof FullSubnetRouter
     */
    expiry?: string | null;
    /**
     * Hostname set by the tailscale client
     * 
     * This value is not used for the DNS.
     * @type {string}
     * @memberof FullSubnetRouter
     */
    hostname: string;
    /**
     * 
     * @type {string}
     * @memberof FullSubnetRouter
     */
    ipv4?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FullSubnetRouter
     */
    ipv6?: string | null;
    /**
     * When was the time the device was online?
     * @type {string}
     * @memberof FullSubnetRouter
     */
    last_seen?: string | null;
    /**
     * Is the device currently online?
     * @type {boolean}
     * @memberof FullSubnetRouter
     */
    online: boolean;
    /**
     * The device's tags
     * @type {Array<SimpleTag>}
     * @memberof FullSubnetRouter
     */
    tags: Array<SimpleTag>;
    /**
     * The primary key
     * @type {string}
     * @memberof FullSubnetRouter
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface FullTag
 */
export interface FullTag {
    /**
     * 
     * @type {string}
     * @memberof FullTag
     */
    description: string;
    /**
     * 
     * @type {Array<FullDevice>}
     * @memberof FullTag
     */
    devices: Array<FullDevice>;
    /**
     * 
     * @type {Array<FullAccessRule>}
     * @memberof FullTag
     */
    inbound_access_rules: Array<FullAccessRule>;
    /**
     * A locked tag's access rules can't be edited
     * @type {boolean}
     * @memberof FullTag
     */
    locked: boolean;
    /**
     * The tag's name (**without** the "tag:" prefix)
     * @type {string}
     * @memberof FullTag
     */
    name: string;
    /**
     * 
     * @type {Array<FullAccessRule>}
     * @memberof FullTag
     */
    outbound_access_rules: Array<FullAccessRule>;
    /**
     * Primary key
     * @type {string}
     * @memberof FullTag
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetAllAccessRuleOptionsResponse
 */
export interface GetAllAccessRuleOptionsResponse {
    /**
     * 
     * @type {Array<SimpleGroup>}
     * @memberof GetAllAccessRuleOptionsResponse
     */
    groups: Array<SimpleGroup>;
    /**
     * 
     * @type {Array<SimpleSubnet>}
     * @memberof GetAllAccessRuleOptionsResponse
     */
    subnets: Array<SimpleSubnet>;
    /**
     * 
     * @type {Array<SimpleTag>}
     * @memberof GetAllAccessRuleOptionsResponse
     */
    tags: Array<SimpleTag>;
}
/**
 * 
 * @export
 * @interface GetAllAccessRulesForResponse
 */
export interface GetAllAccessRulesForResponse {
    /**
     * 
     * @type {Array<FullAccessRule>}
     * @memberof GetAllAccessRulesForResponse
     */
    inbound: Array<FullAccessRule>;
    /**
     * 
     * @type {Array<FullAccessRule>}
     * @memberof GetAllAccessRulesForResponse
     */
    outbound: Array<FullAccessRule>;
}
/**
 * 
 * @export
 * @interface GetAllDevicesRequest
 */
export interface GetAllDevicesRequest {
    /**
     * 
     * @type {boolean}
     * @memberof GetAllDevicesRequest
     */
    filter_is_server?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetAllDevicesRequest
     */
    filter_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAllDevicesRequest
     */
    filter_tag?: string | null;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetAllDevicesRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetAllDevicesRequest
     */
    offset: number;
}
/**
 * A page of items
 * @export
 * @interface GetAllDevicesResponse
 */
export interface GetAllDevicesResponse {
    /**
     * The page's items
     * @type {Array<FullDevice>}
     * @memberof GetAllDevicesResponse
     */
    items: Array<FullDevice>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetAllDevicesResponse
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetAllDevicesResponse
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof GetAllDevicesResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllDevicesResponse
     */
    total_clients: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllDevicesResponse
     */
    total_servers: number;
}
/**
 * Page and filter requests for approved exit nodes
 * @export
 * @interface GetAllExitNodesRequest
 */
export interface GetAllExitNodesRequest {
    /**
     * Filters if the exit node is currently advertising
     * @type {boolean}
     * @memberof GetAllExitNodesRequest
     */
    filter_device_advertises?: boolean | null;
    /**
     * Filters if the exit node is disabled or enabled
     * @type {boolean}
     * @memberof GetAllExitNodesRequest
     */
    filter_is_disabled?: boolean | null;
    /**
     * Filter after the dns name of a devices
     * @type {string}
     * @memberof GetAllExitNodesRequest
     */
    filter_name?: string | null;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetAllExitNodesRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetAllExitNodesRequest
     */
    offset: number;
}
/**
 * 
 * @export
 * @interface GetAllGroupsRequest
 */
export interface GetAllGroupsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAllGroupsRequest
     */
    filter_name?: string | null;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetAllGroupsRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetAllGroupsRequest
     */
    offset: number;
    /**
     * 
     * @type {GroupProvider}
     * @memberof GetAllGroupsRequest
     */
    provider: GroupProvider;
}
/**
 * 
 * @export
 * @interface GetAllGroupsResponseItem
 */
export interface GetAllGroupsResponseItem {
    /**
     * 
     * @type {string}
     * @memberof GetAllGroupsResponseItem
     */
    description: string;
    /**
     * The group's identifier in the synced source of truth
     * 
     * I.e. DN for LDAP syncs
     * @type {string}
     * @memberof GetAllGroupsResponseItem
     */
    external_id: string;
    /**
     * Allows this group to have access to `autogroup:internet`
     * @type {boolean}
     * @memberof GetAllGroupsResponseItem
     */
    internet: boolean;
    /**
     * The number of users in the group
     * @type {number}
     * @memberof GetAllGroupsResponseItem
     */
    members: number;
    /**
     * The group's name (**without** the "group:" prefix)
     * @type {string}
     * @memberof GetAllGroupsResponseItem
     */
    name: string;
    /**
     * 
     * @type {GroupProvider}
     * @memberof GetAllGroupsResponseItem
     */
    provider: GroupProvider;
    /**
     * The group's uuid
     * @type {string}
     * @memberof GetAllGroupsResponseItem
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetAllPreAuthKeysRequest
 */
export interface GetAllPreAuthKeysRequest {
    /**
     * Filters keys by their `ephemeral` field
     * @type {boolean}
     * @memberof GetAllPreAuthKeysRequest
     */
    ephemeral?: boolean | null;
    /**
     * Filters keys if they
     * @type {boolean}
     * @memberof GetAllPreAuthKeysRequest
     */
    expired?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetAllPreAuthKeysRequest
     */
    filter_description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAllPreAuthKeysRequest
     */
    filter_key?: string | null;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetAllPreAuthKeysRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetAllPreAuthKeysRequest
     */
    offset: number;
    /**
     * Filters keys by their `reusable` field
     * @type {boolean}
     * @memberof GetAllPreAuthKeysRequest
     */
    reusable?: boolean | null;
    /**
     * Filters keys by their `used` field
     * @type {boolean}
     * @memberof GetAllPreAuthKeysRequest
     */
    used?: boolean | null;
}
/**
 * 
 * @export
 * @interface GetAllSubnetsRequest
 */
export interface GetAllSubnetsRequest {
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetAllSubnetsRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetAllSubnetsRequest
     */
    offset: number;
}
/**
 * 
 * @export
 * @interface GetAllSubnetsResponseItem
 */
export interface GetAllSubnetsResponseItem {
    /**
     * Description of the subnet
     * @type {string}
     * @memberof GetAllSubnetsResponseItem
     */
    description: string;
    /**
     * Does this network have an associated device routing it?
     * @type {boolean}
     * @memberof GetAllSubnetsResponseItem
     */
    has_router: boolean;
    /**
     * The network's prefix in CIDR
     * @type {string}
     * @memberof GetAllSubnetsResponseItem
     */
    name: string;
    /**
     * The device currently routing this network
     * @type {FullSubnetRouter}
     * @memberof GetAllSubnetsResponseItem
     */
    router?: FullSubnetRouter | null;
    /**
     * Primary key
     * @type {string}
     * @memberof GetAllSubnetsResponseItem
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetAllTagsRequest
 */
export interface GetAllTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAllTagsRequest
     */
    filter_name?: string | null;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetAllTagsRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetAllTagsRequest
     */
    offset: number;
}
/**
 * 
 * @export
 * @interface GetAllUsersRequest
 */
export interface GetAllUsersRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAllUsersRequest
     */
    filter_name?: string | null;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetAllUsersRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetAllUsersRequest
     */
    offset: number;
}
/**
 * 
 * @export
 * @interface GetChangelogRequest
 */
export interface GetChangelogRequest {
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetChangelogRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetChangelogRequest
     */
    offset: number;
}
/**
 * Response item for the frontend
 * @export
 * @interface GetExitNodesResponseItem
 */
export interface GetExitNodesResponseItem {
    /**
     * Does the device currently advertise itself as exit node?
     * @type {boolean}
     * @memberof GetExitNodesResponseItem
     */
    advertise: boolean;
    /**
     * The first time the device advocated itself as exit node.
     * @type {string}
     * @memberof GetExitNodesResponseItem
     */
    created_at: string;
    /**
     * The device which is the exit node
     * @type {ExitNodeDevice}
     * @memberof GetExitNodesResponseItem
     */
    device: ExitNodeDevice;
    /**
     * Is the exit node currently enabled?
     * @type {boolean}
     * @memberof GetExitNodesResponseItem
     */
    enabled: boolean;
    /**
     * The primary key
     * @type {string}
     * @memberof GetExitNodesResponseItem
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetGeneralSettingsResponse
 */
export interface GetGeneralSettingsResponse {
    /**
     * Base domain used by 0trust to generate DNS names for devices in the network. Previously called `headscale_base_domain`.
     * @type {string}
     * @memberof GetGeneralSettingsResponse
     */
    dns_base_domain: string;
    /**
     * Search domains used for headscale's magic DNS
     * @type {Array<string>}
     * @memberof GetGeneralSettingsResponse
     */
    headscale_domains: Array<string>;
    /**
     * Publicly reachable target URL of the 0trust server. Must contain the protocol (HTTPS) as well as any port and path, if required. Previously called `headscale_url`.
     * @type {string}
     * @memberof GetGeneralSettingsResponse
     */
    public_origin: string;
}
/**
 * 
 * @export
 * @interface GetOidcSettingsResponse
 */
export interface GetOidcSettingsResponse {
    /**
     * 
     * @type {OidcSettingsCustomerFrontend}
     * @memberof GetOidcSettingsResponse
     */
    customer_frontend: OidcSettingsCustomerFrontend;
    /**
     * 
     * @type {OidcSettings}
     * @memberof GetOidcSettingsResponse
     */
    customer_tailscale: OidcSettings;
    /**
     * 
     * @type {OidcSettings}
     * @memberof GetOidcSettingsResponse
     */
    internal_frontend: OidcSettings;
}
/**
 * Page and filter requests for pending exit nodes
 * @export
 * @interface GetPendingExitNodesRequest
 */
export interface GetPendingExitNodesRequest {
    /**
     * Filter after the dns name of a devices
     * @type {string}
     * @memberof GetPendingExitNodesRequest
     */
    filter_name?: string | null;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetPendingExitNodesRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetPendingExitNodesRequest
     */
    offset: number;
}
/**
 * 
 * @export
 * @interface GetPendingRoutesRequest
 */
export interface GetPendingRoutesRequest {
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetPendingRoutesRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetPendingRoutesRequest
     */
    offset: number;
}
/**
 * 
 * @export
 * @interface GetPendingRoutesResponseItem
 */
export interface GetPendingRoutesResponseItem {
    /**
     * When was this route first advertised?
     * @type {string}
     * @memberof GetPendingRoutesResponseItem
     */
    created_at: string;
    /**
     * 
     * @type {FullSubnetRouter}
     * @memberof GetPendingRoutesResponseItem
     */
    device: FullSubnetRouter;
    /**
     * 
     * @type {GetPendingRoutesResponseItemSubnet}
     * @memberof GetPendingRoutesResponseItem
     */
    subnet: GetPendingRoutesResponseItemSubnet;
    /**
     * The route's uuid
     * 
     * It can be used to approve or reject this pending route.
     * @type {string}
     * @memberof GetPendingRoutesResponseItem
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetPendingRoutesResponseItemSubnet
 */
export interface GetPendingRoutesResponseItemSubnet {
    /**
     * Has the subnet already been approved once through another route?
     * @type {boolean}
     * @memberof GetPendingRoutesResponseItemSubnet
     */
    approved: boolean;
    /**
     * Description of the subnet
     * @type {string}
     * @memberof GetPendingRoutesResponseItemSubnet
     */
    description: string;
    /**
     * Does this network have an associated device routing it?
     * @type {boolean}
     * @memberof GetPendingRoutesResponseItemSubnet
     */
    has_router: boolean;
    /**
     * The network's prefix in CIDR
     * @type {string}
     * @memberof GetPendingRoutesResponseItemSubnet
     */
    name: string;
    /**
     * Primary key
     * @type {string}
     * @memberof GetPendingRoutesResponseItemSubnet
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetScimSettingsResponse
 */
export interface GetScimSettingsResponse {
    /**
     * Is the scim API enabled?
     * @type {boolean}
     * @memberof GetScimSettingsResponse
     */
    enabled: boolean;
    /**
     * Enables the workaround required for Microsoft Entra
     * @type {boolean}
     * @memberof GetScimSettingsResponse
     */
    entra_workaround: boolean;
    /**
     * Bearer token required by all scim endpoints
     * @type {string}
     * @memberof GetScimSettingsResponse
     */
    token: string;
}
/**
 * 
 * @export
 * @interface GetSingleDeviceResponse
 */
export interface GetSingleDeviceResponse {
    /**
     * When was the device created?
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    created_at: string;
    /**
     * Name this device is named in the dns
     * 
     * This value is inferred from `hostname` but can be overwritten by an admin.
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    dnsname: string;
    /**
     * Has the device' session expired?
     * @type {boolean}
     * @memberof GetSingleDeviceResponse
     */
    expired: boolean;
    /**
     * When will the device's current session expire?
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    expiry?: string | null;
    /**
     * The extra records for this device
     * @type {Array<SimpleExtraDnsDomain>}
     * @memberof GetSingleDeviceResponse
     */
    extra_records: Array<SimpleExtraDnsDomain>;
    /**
     * Hostname set by the tailscale client
     * 
     * This value is not used for the DNS.
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    hostname: string;
    /**
     * 
     * @type {FullDeviceAccessRules}
     * @memberof GetSingleDeviceResponse
     */
    inbound_access_rules: FullDeviceAccessRules;
    /**
     * 
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    ipv4?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    ipv6?: string | null;
    /**
     * When was the time the device was online?
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    last_seen?: string | null;
    /**
     * Is the device currently online?
     * @type {boolean}
     * @memberof GetSingleDeviceResponse
     */
    online: boolean;
    /**
     * 
     * @type {FullDeviceAccessRules}
     * @memberof GetSingleDeviceResponse
     */
    outbound_access_rules: FullDeviceAccessRules;
    /**
     * 
     * @type {Array<SimpleSubnet>}
     * @memberof GetSingleDeviceResponse
     */
    subnets: Array<SimpleSubnet>;
    /**
     * The device's tags **if** the device is a server device
     * @type {Array<SimpleTag>}
     * @memberof GetSingleDeviceResponse
     */
    tags?: Array<SimpleTag> | null;
    /**
     * The device's user **if** the device is a user device
     * @type {SimpleUser}
     * @memberof GetSingleDeviceResponse
     */
    user?: SimpleUser | null;
    /**
     * The primary key
     * @type {string}
     * @memberof GetSingleDeviceResponse
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetSingleGroupMembersRequest
 */
export interface GetSingleGroupMembersRequest {
    /**
     * 
     * @type {string}
     * @memberof GetSingleGroupMembersRequest
     */
    filter_name?: string | null;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof GetSingleGroupMembersRequest
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof GetSingleGroupMembersRequest
     */
    offset: number;
}
/**
 * 
 * @export
 * @interface GetSingleGroupResponse
 */
export interface GetSingleGroupResponse {
    /**
     * 
     * @type {GetAllAccessRulesForResponse}
     * @memberof GetSingleGroupResponse
     */
    access_rules: GetAllAccessRulesForResponse;
    /**
     * 
     * @type {string}
     * @memberof GetSingleGroupResponse
     */
    description: string;
    /**
     * The group's identifier in the synced source of truth
     * 
     * I.e. DN for LDAP syncs
     * @type {string}
     * @memberof GetSingleGroupResponse
     */
    external_id: string;
    /**
     * Allows this group to have access to `autogroup:internet`
     * @type {boolean}
     * @memberof GetSingleGroupResponse
     */
    internet: boolean;
    /**
     * The group's name (**without** the "group:" prefix)
     * @type {string}
     * @memberof GetSingleGroupResponse
     */
    name: string;
    /**
     * 
     * @type {GroupProvider}
     * @memberof GetSingleGroupResponse
     */
    provider: GroupProvider;
    /**
     * The group's uuid
     * @type {string}
     * @memberof GetSingleGroupResponse
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface GetSingleUserResponse
 */
export interface GetSingleUserResponse {
    /**
     * When the user was created
     * @type {string}
     * @memberof GetSingleUserResponse
     */
    created_at: string;
    /**
     * A name for humans to identify the user by
     * @type {string}
     * @memberof GetSingleUserResponse
     */
    display_name: string;
    /**
     * The user's identifier in the synced source of truth
     * 
     * I.e. DN for LDAP syncs
     * 
     * This might be `null` if the user already logged in via openid connect before the ldap synced him.
     * @type {string}
     * @memberof GetSingleUserResponse
     */
    external_id?: string | null;
    /**
     * The groups which the user is assigned to
     * @type {Array<SimpleGroup>}
     * @memberof GetSingleUserResponse
     */
    groups: Array<SimpleGroup>;
    /**
     * The user's uuid
     * @type {string}
     * @memberof GetSingleUserResponse
     */
    uuid: string;
}

/**
 * 
 * @export
 */
export const GlobalDnsType = {
    Google: 'Google',
    Cloudflare: 'Cloudflare',
    Quad9: 'Quad9',
    Custom: 'Custom'
} as const;
export type GlobalDnsType = typeof GlobalDnsType[keyof typeof GlobalDnsType];


/**
 * 
 * @export
 */
export const GroupProvider = {
    Ldap: 'Ldap',
    Local: 'Local',
    Scim: 'Scim'
} as const;
export type GroupProvider = typeof GroupProvider[keyof typeof GroupProvider];

/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForFullAccessRule
 */
export interface ListForFullAccessRule {
    /**
     * 
     * @type {Array<FullAccessRule>}
     * @memberof ListForFullAccessRule
     */
    list: Array<FullAccessRule>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForFullExtraDnsDomain
 */
export interface ListForFullExtraDnsDomain {
    /**
     * 
     * @type {Array<FullExtraDnsDomain>}
     * @memberof ListForFullExtraDnsDomain
     */
    list: Array<FullExtraDnsDomain>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForFullSplitDnsDomain
 */
export interface ListForFullSplitDnsDomain {
    /**
     * 
     * @type {Array<FullSplitDnsDomain>}
     * @memberof ListForFullSplitDnsDomain
     */
    list: Array<FullSplitDnsDomain>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForSimpleAccount
 */
export interface ListForSimpleAccount {
    /**
     * 
     * @type {Array<SimpleAccount>}
     * @memberof ListForSimpleAccount
     */
    list: Array<SimpleAccount>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForSimpleChangelogEntry
 */
export interface ListForSimpleChangelogEntry {
    /**
     * 
     * @type {Array<SimpleChangelogEntry>}
     * @memberof ListForSimpleChangelogEntry
     */
    list: Array<SimpleChangelogEntry>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForSimpleDnsSearchDomain
 */
export interface ListForSimpleDnsSearchDomain {
    /**
     * 
     * @type {Array<SimpleDnsSearchDomain>}
     * @memberof ListForSimpleDnsSearchDomain
     */
    list: Array<SimpleDnsSearchDomain>;
}
/**
 * A single field which is an array.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Vec<T>>` from your handler, please use `ApiJson<List<T>>` instead.
 * 
 * It simply wraps the vector into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface ListForSimpleExtraDnsDomain
 */
export interface ListForSimpleExtraDnsDomain {
    /**
     * 
     * @type {Array<SimpleExtraDnsDomain>}
     * @memberof ListForSimpleExtraDnsDomain
     */
    list: Array<SimpleExtraDnsDomain>;
}
/**
 * 
 * @export
 * @interface MoveDnsSearchDomainRequest
 */
export interface MoveDnsSearchDomainRequest {
    /**
     * The domain's new index
     * 
     * This index references to the list of search domains **without** the domain to be moved.
     * @type {number}
     * @memberof MoveDnsSearchDomainRequest
     */
    new_index: number;
    /**
     * The domain's old index
     * 
     * This index is used to identify the domain to move.
     * @type {number}
     * @memberof MoveDnsSearchDomainRequest
     */
    old_index: number;
}
/**
 * 
 * @export
 * @interface OidcSettings
 */
export interface OidcSettings {
    /**
     * 
     * @type {string}
     * @memberof OidcSettings
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof OidcSettings
     */
    client_secret: string;
    /**
     * 
     * @type {boolean}
     * @memberof OidcSettings
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof OidcSettings
     */
    redirect_url: string;
    /**
     * 
     * @type {string}
     * @memberof OidcSettings
     */
    url: string;
}
/**
 * 
 * @export
 * @interface OidcSettingsCustomerFrontend
 */
export interface OidcSettingsCustomerFrontend {
    /**
     * 
     * @type {string}
     * @memberof OidcSettingsCustomerFrontend
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof OidcSettingsCustomerFrontend
     */
    client_secret: string;
    /**
     * 
     * @type {boolean}
     * @memberof OidcSettingsCustomerFrontend
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OidcSettingsCustomerFrontend
     */
    full_permissions: boolean;
    /**
     * 
     * @type {string}
     * @memberof OidcSettingsCustomerFrontend
     */
    redirect_url: string;
    /**
     * 
     * @type {string}
     * @memberof OidcSettingsCustomerFrontend
     */
    url: string;
}
/**
 * A single field which might be `null`.
 * 
 * ## Rust Usage
 * 
 * If you want to return an `ApiJson<Option<T>>` from your handler, please use `ApiJson<Optional<T>>` instead.
 * 
 * It simply wraps the option into a struct with a single field to ensure the json returned from a handler is always an object.
 * @export
 * @interface OptionalForSimpleGroup
 */
export interface OptionalForSimpleGroup {
    /**
     * 
     * @type {SimpleGroup}
     * @memberof OptionalForSimpleGroup
     */
    optional?: SimpleGroup | null;
}
/**
 * A page of items
 * @export
 * @interface PageForFullHeadscalePreAuthKey
 */
export interface PageForFullHeadscalePreAuthKey {
    /**
     * The page's items
     * @type {Array<FullHeadscalePreAuthKey>}
     * @memberof PageForFullHeadscalePreAuthKey
     */
    items: Array<FullHeadscalePreAuthKey>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForFullHeadscalePreAuthKey
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForFullHeadscalePreAuthKey
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForFullHeadscalePreAuthKey
     */
    total: number;
}
/**
 * A page of items
 * @export
 * @interface PageForGetAllGroupsResponseItem
 */
export interface PageForGetAllGroupsResponseItem {
    /**
     * The page's items
     * @type {Array<GetAllGroupsResponseItem>}
     * @memberof PageForGetAllGroupsResponseItem
     */
    items: Array<GetAllGroupsResponseItem>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForGetAllGroupsResponseItem
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForGetAllGroupsResponseItem
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForGetAllGroupsResponseItem
     */
    total: number;
}
/**
 * A page of items
 * @export
 * @interface PageForGetAllSubnetsResponseItem
 */
export interface PageForGetAllSubnetsResponseItem {
    /**
     * The page's items
     * @type {Array<GetAllSubnetsResponseItem>}
     * @memberof PageForGetAllSubnetsResponseItem
     */
    items: Array<GetAllSubnetsResponseItem>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForGetAllSubnetsResponseItem
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForGetAllSubnetsResponseItem
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForGetAllSubnetsResponseItem
     */
    total: number;
}
/**
 * A page of items
 * @export
 * @interface PageForGetExitNodesResponseItem
 */
export interface PageForGetExitNodesResponseItem {
    /**
     * The page's items
     * @type {Array<GetExitNodesResponseItem>}
     * @memberof PageForGetExitNodesResponseItem
     */
    items: Array<GetExitNodesResponseItem>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForGetExitNodesResponseItem
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForGetExitNodesResponseItem
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForGetExitNodesResponseItem
     */
    total: number;
}
/**
 * A page of items
 * @export
 * @interface PageForGetPendingRoutesResponseItem
 */
export interface PageForGetPendingRoutesResponseItem {
    /**
     * The page's items
     * @type {Array<GetPendingRoutesResponseItem>}
     * @memberof PageForGetPendingRoutesResponseItem
     */
    items: Array<GetPendingRoutesResponseItem>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForGetPendingRoutesResponseItem
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForGetPendingRoutesResponseItem
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForGetPendingRoutesResponseItem
     */
    total: number;
}
/**
 * A page of items
 * @export
 * @interface PageForSimpleChangelogEntry
 */
export interface PageForSimpleChangelogEntry {
    /**
     * The page's items
     * @type {Array<SimpleChangelogEntry>}
     * @memberof PageForSimpleChangelogEntry
     */
    items: Array<SimpleChangelogEntry>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForSimpleChangelogEntry
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForSimpleChangelogEntry
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForSimpleChangelogEntry
     */
    total: number;
}
/**
 * A page of items
 * @export
 * @interface PageForSimpleTag
 */
export interface PageForSimpleTag {
    /**
     * The page's items
     * @type {Array<SimpleTag>}
     * @memberof PageForSimpleTag
     */
    items: Array<SimpleTag>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForSimpleTag
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForSimpleTag
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForSimpleTag
     */
    total: number;
}
/**
 * A page of items
 * @export
 * @interface PageForSimpleUser
 */
export interface PageForSimpleUser {
    /**
     * The page's items
     * @type {Array<SimpleUser>}
     * @memberof PageForSimpleUser
     */
    items: Array<SimpleUser>;
    /**
     * The limit this page was requested with
     * @type {number}
     * @memberof PageForSimpleUser
     */
    limit: number;
    /**
     * The offset this page was requested with
     * @type {number}
     * @memberof PageForSimpleUser
     */
    offset: number;
    /**
     * The total number of items this page is a subset of
     * @type {number}
     * @memberof PageForSimpleUser
     */
    total: number;
}
/**
 * A group or user found by a search
 * 
 * This struct is part of [`SearchResults`]
 * @export
 * @interface SearchResultsEntry
 */
export interface SearchResultsEntry {
    /**
     * The group's members or the user's groups
     * 
     * This field is only populated for one of those two, which one depends on the [`SearchParams`]'s `membership_in_group` flag
     * @type {Array<string>}
     * @memberof SearchResultsEntry
     */
    list: Array<string>;
    /**
     * The group's or user's name
     * @type {string}
     * @memberof SearchResultsEntry
     */
    name: string;
}
/**
 * 
 * @export
 * @interface SetDeviceDnsnameErrors
 */
export interface SetDeviceDnsnameErrors {
    /**
     * 
     * @type {boolean}
     * @memberof SetDeviceDnsnameErrors
     */
    dnsname_not_unique: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SetDeviceDnsnameErrors
     */
    extra_dns_exists: boolean;
}
/**
 * 
 * @export
 * @interface SetDeviceDnsnameRequest
 */
export interface SetDeviceDnsnameRequest {
    /**
     * 
     * @type {string}
     * @memberof SetDeviceDnsnameRequest
     */
    dnsname: string;
}
/**
 * 
 * @export
 * @interface SetGeneralSettingsErrors
 */
export interface SetGeneralSettingsErrors {
    /**
     * A device's name with the new base domain with conflict with an extra record
     * @type {boolean}
     * @memberof SetGeneralSettingsErrors
     */
    conflicting_device_and_domain: boolean;
}
/**
 * 
 * @export
 * @interface SetGeneralSettingsRequest
 */
export interface SetGeneralSettingsRequest {
    /**
     * Base domain used by 0trust to generate DNS names for devices in the network. Previously called `headscale_base_domain`.
     * @type {string}
     * @memberof SetGeneralSettingsRequest
     */
    dns_base_domain?: string | null;
    /**
     * Publicly reachable target URL of the 0trust server. Must contain the protocol (HTTPS) as well as any port and path, if required. Previously called `headscale_url`.
     * @type {string}
     * @memberof SetGeneralSettingsRequest
     */
    public_origin?: string | null;
}
/**
 * 
 * @export
 * @interface SetLdapConnectionSettingsErrors
 */
export interface SetLdapConnectionSettingsErrors {
    /**
     * 
     * @type {boolean}
     * @memberof SetLdapConnectionSettingsErrors
     */
    url_invalid: boolean;
}
/**
 * 
 * @export
 * @interface SetLdapConnectionSettingsRequest
 */
export interface SetLdapConnectionSettingsRequest {
    /**
     * Is the ldap sync enabled?
     * @type {boolean}
     * @memberof SetLdapConnectionSettingsRequest
     */
    ldap_enabled: boolean;
    /**
     * The password to authenticate with at ldap
     * @type {string}
     * @memberof SetLdapConnectionSettingsRequest
     */
    ldap_password: string;
    /**
     * The url under which the backend can reach the ldap
     * @type {string}
     * @memberof SetLdapConnectionSettingsRequest
     */
    ldap_url: string;
    /**
     * The username to authenticate with at ldap
     * @type {string}
     * @memberof SetLdapConnectionSettingsRequest
     */
    ldap_user: string;
}
/**
 * 
 * @export
 * @interface SetLdapQuerySettingsRequest
 */
export interface SetLdapQuerySettingsRequest {
    /**
     * The dn to search for groups
     * @type {string}
     * @memberof SetLdapQuerySettingsRequest
     */
    group_base: string;
    /**
     * The filter to use when searching for groups
     * @type {string}
     * @memberof SetLdapQuerySettingsRequest
     */
    group_filter: string;
    /**
     * LDAP attribute containing the group's name
     * @type {string}
     * @memberof SetLdapQuerySettingsRequest
     */
    group_name: string;
    /**
     * LDAP attribute which stores the membership relation between groups and users
     * 
     * The flag `membership_in_group` stores whether this attribute is found on groups or users
     * @type {string}
     * @memberof SetLdapQuerySettingsRequest
     */
    membership_attr: string;
    /**
     * Is the `membership_attr` set for groups and stores the list of users which are members of the group?
     * 
     * Alternatively, the `membership_attr` is set for users and stores the list of groups the user is member of.
     * @type {boolean}
     * @memberof SetLdapQuerySettingsRequest
     */
    membership_in_group: boolean;
    /**
     * The dn to search for users
     * @type {string}
     * @memberof SetLdapQuerySettingsRequest
     */
    user_base: string;
    /**
     * The filter to use when searching for users
     * @type {string}
     * @memberof SetLdapQuerySettingsRequest
     */
    user_filter: string;
    /**
     * LDAP attribute containing the user's name
     * @type {string}
     * @memberof SetLdapQuerySettingsRequest
     */
    user_name: string;
}
/**
 * 
 * @export
 * @interface SetLdapSettingsErrors
 */
export interface SetLdapSettingsErrors {
    /**
     * 
     * @type {string}
     * @memberof SetLdapSettingsErrors
     */
    group_filter_invalid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetLdapSettingsErrors
     */
    user_filter_invalid?: string | null;
}
/**
 * 
 * @export
 * @interface SetScimSettingsRequest
 */
export interface SetScimSettingsRequest {
    /**
     * Is the scim API enabled?
     * @type {boolean}
     * @memberof SetScimSettingsRequest
     */
    enabled: boolean;
    /**
     * Enables the workaround required for Microsoft Entra
     * @type {boolean}
     * @memberof SetScimSettingsRequest
     */
    entra_workaround: boolean;
    /**
     * Bearer token required by all scim endpoints
     * @type {string}
     * @memberof SetScimSettingsRequest
     */
    token: string;
}
/**
 * 
 * @export
 * @interface SetTagDescriptionRequest
 */
export interface SetTagDescriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof SetTagDescriptionRequest
     */
    description: string;
}
/**
 * 
 * @export
 * @interface SetTagNameErrors
 */
export interface SetTagNameErrors {
    /**
     * 
     * @type {boolean}
     * @memberof SetTagNameErrors
     */
    name_not_unique: boolean;
}
/**
 * 
 * @export
 * @interface SetTagNameRequest
 */
export interface SetTagNameRequest {
    /**
     * 
     * @type {string}
     * @memberof SetTagNameRequest
     */
    name: string;
}
/**
 * 
 * @export
 * @interface SimpleAccount
 */
export interface SimpleAccount {
    /**
     * The name that is used for displaying purposes
     * @type {string}
     * @memberof SimpleAccount
     */
    display_name: string;
    /**
     * The mail of the account
     * @type {string}
     * @memberof SimpleAccount
     */
    mail: string;
    /**
     * The permissions this account has
     * @type {AccountPermissions}
     * @memberof SimpleAccount
     */
    permissions: AccountPermissions;
    /**
     * Primary key
     * @type {string}
     * @memberof SimpleAccount
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimpleChangelogEntry
 */
export interface SimpleChangelogEntry {
    /**
     * Timestamp when the entry was created i.e. the change was performed
     * @type {string}
     * @memberof SimpleChangelogEntry
     */
    created_at: string;
    /**
     * Additional data
     * 
     * This is a json object a user should be able to understand.
     * @type {any}
     * @memberof SimpleChangelogEntry
     */
    data: any | null;
    /**
     * Was the object created, updated or deleted?
     * @type {ChangelogOperation}
     * @memberof SimpleChangelogEntry
     */
    operation: ChangelogOperation;
    /**
     * The name of the object which was changed
     * 
     * The concrete interpretation of the name is dependent on the `target_type`. But generally, a human can hopefully identify the object using its type and name.
     * @type {string}
     * @memberof SimpleChangelogEntry
     */
    target_name: string;
    /**
     * The type of the object which was changed
     * @type {ChangelogTarget}
     * @memberof SimpleChangelogEntry
     */
    target_type: ChangelogTarget;
    /**
     * Mail address of the person which performed the change
     * @type {string}
     * @memberof SimpleChangelogEntry
     */
    user_mail: string;
    /**
     * Name of the person which performed the change
     * @type {string}
     * @memberof SimpleChangelogEntry
     */
    user_name: string;
}
/**
 * 
 * @export
 * @interface SimpleDnsSearchDomain
 */
export interface SimpleDnsSearchDomain {
    /**
     * The domain to use as search domain
     * 
     * It must be a FQDN without a trailing dot.
     * @type {string}
     * @memberof SimpleDnsSearchDomain
     */
    domain: string;
    /**
     * Primary key
     * @type {string}
     * @memberof SimpleDnsSearchDomain
     */
    uuid: string;
}
/**
 * Simple representation of an extra DNS domain.
 * @export
 * @interface SimpleExtraDnsDomain
 */
export interface SimpleExtraDnsDomain {
    /**
     * Description
     * @type {string}
     * @memberof SimpleExtraDnsDomain
     */
    description: string;
    /**
     * The fully qualified domain name
     * @type {string}
     * @memberof SimpleExtraDnsDomain
     */
    from_dns: string;
    /**
     * The primary key
     * @type {string}
     * @memberof SimpleExtraDnsDomain
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimpleGroup
 */
export interface SimpleGroup {
    /**
     * 
     * @type {string}
     * @memberof SimpleGroup
     */
    description: string;
    /**
     * The group's identifier in the synced source of truth
     * 
     * I.e. DN for LDAP syncs
     * @type {string}
     * @memberof SimpleGroup
     */
    external_id: string;
    /**
     * Allows this group to have access to `autogroup:internet`
     * @type {boolean}
     * @memberof SimpleGroup
     */
    internet: boolean;
    /**
     * The group's name (**without** the "group:" prefix)
     * @type {string}
     * @memberof SimpleGroup
     */
    name: string;
    /**
     * 
     * @type {GroupProvider}
     * @memberof SimpleGroup
     */
    provider: GroupProvider;
    /**
     * The group's uuid
     * @type {string}
     * @memberof SimpleGroup
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimpleSubnet
 */
export interface SimpleSubnet {
    /**
     * Description of the subnet
     * @type {string}
     * @memberof SimpleSubnet
     */
    description: string;
    /**
     * Does this network have an associated device routing it?
     * @type {boolean}
     * @memberof SimpleSubnet
     */
    has_router: boolean;
    /**
     * The network's prefix in CIDR
     * @type {string}
     * @memberof SimpleSubnet
     */
    name: string;
    /**
     * Primary key
     * @type {string}
     * @memberof SimpleSubnet
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimpleTag
 */
export interface SimpleTag {
    /**
     * 
     * @type {string}
     * @memberof SimpleTag
     */
    description: string;
    /**
     * A locked tag's access rules can't be edited
     * @type {boolean}
     * @memberof SimpleTag
     */
    locked: boolean;
    /**
     * The tag's name (**without** the "tag:" prefix)
     * @type {string}
     * @memberof SimpleTag
     */
    name: string;
    /**
     * Primary key
     * @type {string}
     * @memberof SimpleTag
     */
    uuid: string;
}
/**
 * 
 * @export
 * @interface SimpleUser
 */
export interface SimpleUser {
    /**
     * When the user was created
     * @type {string}
     * @memberof SimpleUser
     */
    created_at: string;
    /**
     * A name for humans to identify the user by
     * @type {string}
     * @memberof SimpleUser
     */
    display_name: string;
    /**
     * The user's identifier in the synced source of truth
     * 
     * I.e. DN for LDAP syncs
     * 
     * This might be `null` if the user already logged in via openid connect before the ldap synced him.
     * @type {string}
     * @memberof SimpleUser
     */
    external_id?: string | null;
    /**
     * The user's uuid
     * @type {string}
     * @memberof SimpleUser
     */
    uuid: string;
}
/**
 * A single uuid wrapped in a struct
 * @export
 * @interface SingleUuid
 */
export interface SingleUuid {
    /**
     * 
     * @type {string}
     * @memberof SingleUuid
     */
    uuid: string;
}
/**
 * Subnet description request
 * @export
 * @interface SubnetsDescriptionRequest
 */
export interface SubnetsDescriptionRequest {
    /**
     * The description of the subnet
     * @type {string}
     * @memberof SubnetsDescriptionRequest
     */
    description: string;
}
/**
 * @type TestLdapSearchResponse
 * 
 * @export
 */
export type TestLdapSearchResponse = TestLdapSearchResponseOneOf | TestLdapSearchResponseOneOf1;
/**
 * Results of a search for groups and users.
 * 
 * This struct is the return type of [`search_groups_and_users`].
 * @export
 * @interface TestLdapSearchResponseOneOf
 */
export interface TestLdapSearchResponseOneOf {
    /**
     * Groups found by the search.
     * 
     * Map from dn to name and members.
     * @type {{ [key: string]: SearchResultsEntry | undefined; }}
     * @memberof TestLdapSearchResponseOneOf
     */
    groups: { [key: string]: SearchResultsEntry | undefined; };
    /**
     * Dns which were not utf-8
     * 
     * This can only happen for the values in a group's member attribute.
     * 
     * List of partially decoded dns (i.e. `String::from_utf8_lossy`)
     * @type {Array<string>}
     * @memberof TestLdapSearchResponseOneOf
     */
    invalid_dns: Array<string>;
    /**
     * Entries which had to be skipped because their names were not utf-8
     * 
     * Map from dn to partially decoded name (i.e. `String::from_utf8_lossy`)
     * @type {{ [key: string]: string | undefined; }}
     * @memberof TestLdapSearchResponseOneOf
     */
    invalid_names: { [key: string]: string | undefined; };
    /**
     * Entries whose dn were longer than our db allows
     * @type {Array<string>}
     * @memberof TestLdapSearchResponseOneOf
     */
    long_dns: Array<string>;
    /**
     * Entries which had to be skipped because their names were longer than our db allows
     * 
     * Map from dn to name
     * @type {{ [key: string]: string | undefined; }}
     * @memberof TestLdapSearchResponseOneOf
     */
    long_names: { [key: string]: string | undefined; };
    /**
     * Entries which had to be skipped because they didn't have the name attribute
     * 
     * List of dns
     * @type {Array<string>}
     * @memberof TestLdapSearchResponseOneOf
     */
    missing_names: Array<string>;
    /**
     * Entries which had multiple names (they were not skipped and are part of `groups`)
     * 
     * List of dns
     * @type {Array<string>}
     * @memberof TestLdapSearchResponseOneOf
     */
    mutliple_names: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TestLdapSearchResponseOneOf
     */
    type: TestLdapSearchResponseOneOfTypeEnum;
    /**
     * Users found by the search.
     * 
     * Map from dn to name.
     * @type {{ [key: string]: SearchResultsEntry | undefined; }}
     * @memberof TestLdapSearchResponseOneOf
     */
    users: { [key: string]: SearchResultsEntry | undefined; };
}


/**
 * @export
 */
export const TestLdapSearchResponseOneOfTypeEnum = {
    Success: 'Success'
} as const;
export type TestLdapSearchResponseOneOfTypeEnum = typeof TestLdapSearchResponseOneOfTypeEnum[keyof typeof TestLdapSearchResponseOneOfTypeEnum];

/**
 * 
 * @export
 * @interface TestLdapSearchResponseOneOf1
 */
export interface TestLdapSearchResponseOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof TestLdapSearchResponseOneOf1
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof TestLdapSearchResponseOneOf1
     */
    type: TestLdapSearchResponseOneOf1TypeEnum;
}


/**
 * @export
 */
export const TestLdapSearchResponseOneOf1TypeEnum = {
    Error: 'Error'
} as const;
export type TestLdapSearchResponseOneOf1TypeEnum = typeof TestLdapSearchResponseOneOf1TypeEnum[keyof typeof TestLdapSearchResponseOneOf1TypeEnum];

/**
 * 
 * @export
 * @interface TestLdapSettingsErrors
 */
export interface TestLdapSettingsErrors {
    /**
     * 
     * @type {string}
     * @memberof TestLdapSettingsErrors
     */
    group_filter_invalid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TestLdapSettingsErrors
     */
    user_filter_invalid?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateAccessRuleRequest
 */
export interface UpdateAccessRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAccessRuleRequest
     */
    description?: string | null;
    /**
     * 
     * @type {CreateAccessRuleDst}
     * @memberof UpdateAccessRuleRequest
     */
    dst?: CreateAccessRuleDst | null;
    /**
     * 
     * @type {CreateAccessRulePort}
     * @memberof UpdateAccessRuleRequest
     */
    port?: CreateAccessRulePort | null;
    /**
     * 
     * @type {AccessRuleProtocol}
     * @memberof UpdateAccessRuleRequest
     */
    protocol?: AccessRuleProtocol | null;
    /**
     * 
     * @type {CreateAccessRuleSrc}
     * @memberof UpdateAccessRuleRequest
     */
    src?: CreateAccessRuleSrc | null;
}
/**
 * 
 * @export
 * @interface UpdateExtraDnsDomainError
 */
export interface UpdateExtraDnsDomainError {
    /**
     * If an existing device has the same name
     * @type {boolean}
     * @memberof UpdateExtraDnsDomainError
     */
    device_already_exists: boolean;
    /**
     * If an existing domain has the same name
     * @type {boolean}
     * @memberof UpdateExtraDnsDomainError
     */
    domain_already_exists: boolean;
    /**
     * Invalid domain
     * @type {boolean}
     * @memberof UpdateExtraDnsDomainError
     */
    domain_invalid: boolean;
}
/**
 * 
 * @export
 * @interface UpdateExtraDnsDomainRequest
 */
export interface UpdateExtraDnsDomainRequest {
    /**
     * Description
     * @type {string}
     * @memberof UpdateExtraDnsDomainRequest
     */
    description: string;
    /**
     * The fully qualified domain name
     * @type {string}
     * @memberof UpdateExtraDnsDomainRequest
     */
    from_dns: string;
}
/**
 * 
 * @export
 * @interface UpdateExtraDnsRecordError
 */
export interface UpdateExtraDnsRecordError {
    /**
     * The ip of the record is not a valid ip
     * @type {boolean}
     * @memberof UpdateExtraDnsRecordError
     */
    ip_invalid: boolean;
    /**
     * If the IP is in the internal range but no device exists
     * @type {boolean}
     * @memberof UpdateExtraDnsRecordError
     */
    no_internal_device: boolean;
}
/**
 * 
 * @export
 * @interface UpdateExtraDnsRecordRequest
 */
export interface UpdateExtraDnsRecordRequest {
    /**
     * The record type, A or AAAA accepted
     * @type {ExtraDnsRecordType}
     * @memberof UpdateExtraDnsRecordRequest
     */
    record_type: ExtraDnsRecordType;
    /**
     * The IP of the Record
     * @type {string}
     * @memberof UpdateExtraDnsRecordRequest
     */
    to_ip: string;
}
/**
 * Update Errors for the Global DNS
 * @export
 * @interface UpdateGlobalDnsErrors
 */
export interface UpdateGlobalDnsErrors {
    /**
     * If the ipv4 provider is not valid
     * @type {boolean}
     * @memberof UpdateGlobalDnsErrors
     */
    ipv4_provider1: boolean;
    /**
     * If the ipv4 provider is not valid
     * @type {boolean}
     * @memberof UpdateGlobalDnsErrors
     */
    ipv4_provider2: boolean;
    /**
     * If the ipv4 provider is not valid
     * @type {boolean}
     * @memberof UpdateGlobalDnsErrors
     */
    ipv4_provider3: boolean;
    /**
     * If the ipv6 provider is not valid
     * @type {boolean}
     * @memberof UpdateGlobalDnsErrors
     */
    ipv6_provider1: boolean;
    /**
     * If the ipv6 provider is not valid
     * @type {boolean}
     * @memberof UpdateGlobalDnsErrors
     */
    ipv6_provider2: boolean;
    /**
     * If the ipv6 provider is not valid
     * @type {boolean}
     * @memberof UpdateGlobalDnsErrors
     */
    ipv6_provider3: boolean;
    /**
     * If no IP address is provided
     * @type {boolean}
     * @memberof UpdateGlobalDnsErrors
     */
    missing_ip_address: boolean;
}
/**
 * 
 * @export
 * @interface UpdateGroupRequest
 */
export interface UpdateGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupRequest
     */
    description?: string | null;
    /**
     * Allows this group to have access to `autogroup:internet`
     * @type {boolean}
     * @memberof UpdateGroupRequest
     */
    internet?: boolean | null;
}
/**
 * 
 * @export
 * @interface UpdateOidcSettingsRequest
 */
export interface UpdateOidcSettingsRequest {
    /**
     * 
     * @type {OidcSettingsCustomerFrontend}
     * @memberof UpdateOidcSettingsRequest
     */
    customer_frontend?: OidcSettingsCustomerFrontend | null;
    /**
     * 
     * @type {OidcSettings}
     * @memberof UpdateOidcSettingsRequest
     */
    customer_tailscale?: OidcSettings | null;
}
/**
 * Error response for updating a Split Dns Domain
 * @export
 * @interface UpdateSplitDnsDomainError
 */
export interface UpdateSplitDnsDomainError {
    /**
     * The domain name is already used by another split dns domain
     * @type {boolean}
     * @memberof UpdateSplitDnsDomainError
     */
    domain_already_exists: boolean;
    /**
     * The name of the domain which is not a valid domain
     * @type {boolean}
     * @memberof UpdateSplitDnsDomainError
     */
    domain_invalid: boolean;
}
/**
 * Request for updating a Split Dns Domain
 * @export
 * @interface UpdateSplitDnsDomainRequest
 */
export interface UpdateSplitDnsDomainRequest {
    /**
     * Marks whether this Split Dns configuration is actively used or not
     * @type {boolean}
     * @memberof UpdateSplitDnsDomainRequest
     */
    disabled: boolean;
    /**
     * The domain name
     * @type {string}
     * @memberof UpdateSplitDnsDomainRequest
     */
    domain: string;
}
/**
 * Errors for creating a new split dns resolver
 * @export
 * @interface UpdateSplitDnsResolverErrors
 */
export interface UpdateSplitDnsResolverErrors {
    /**
     * Ip address is already in use in this domain
     * @type {boolean}
     * @memberof UpdateSplitDnsResolverErrors
     */
    ip_already_exists: boolean;
    /**
     * Ip address is not a valid ip address
     * @type {boolean}
     * @memberof UpdateSplitDnsResolverErrors
     */
    ip_invalid: boolean;
}
/**
 * Request for creating a new split dns resolver
 * @export
 * @interface UpdateSplitDnsResolverRequest
 */
export interface UpdateSplitDnsResolverRequest {
    /**
     * Better description to identify the resolver
     * @type {string}
     * @memberof UpdateSplitDnsResolverRequest
     */
    description: string;
    /**
     * Marks whether this resolver is actively used or not
     * @type {boolean}
     * @memberof UpdateSplitDnsResolverRequest
     */
    disabled: boolean;
    /**
     * The IP of the resolver
     * @type {string}
     * @memberof UpdateSplitDnsResolverRequest
     */
    ip: string;
}
/**
 * Websocket messages sent from the client to the server
 * @export
 * @interface WsClientMsg
 */
export interface WsClientMsg {
}
/**
 * @type WsServerMsg
 * Websocket messages sent from the server to the client
 * @export
 */
export type WsServerMsg = WsServerMsgOneOf | WsServerMsgOneOf1 | WsServerMsgOneOf2 | WsServerMsgOneOf3 | WsServerMsgOneOf4 | WsServerMsgOneOf5 | WsServerMsgOneOf6 | WsServerMsgOneOf7 | WsServerMsgOneOf8;
/**
 * The client send an invalid message
 * @export
 * @interface WsServerMsgOneOf
 */
export interface WsServerMsgOneOf {
    /**
     * The invalid message
     * @type {string}
     * @memberof WsServerMsgOneOf
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf
     */
    type: WsServerMsgOneOfTypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOfTypeEnum = {
    InvalidMsg: 'InvalidMsg'
} as const;
export type WsServerMsgOneOfTypeEnum = typeof WsServerMsgOneOfTypeEnum[keyof typeof WsServerMsgOneOfTypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf1
 */
export interface WsServerMsgOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf1
     */
    type: WsServerMsgOneOf1TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf1TypeEnum = {
    TagsChanged: 'TagsChanged'
} as const;
export type WsServerMsgOneOf1TypeEnum = typeof WsServerMsgOneOf1TypeEnum[keyof typeof WsServerMsgOneOf1TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf2
 */
export interface WsServerMsgOneOf2 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf2
     */
    type: WsServerMsgOneOf2TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf2TypeEnum = {
    GroupsChanged: 'GroupsChanged'
} as const;
export type WsServerMsgOneOf2TypeEnum = typeof WsServerMsgOneOf2TypeEnum[keyof typeof WsServerMsgOneOf2TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf3
 */
export interface WsServerMsgOneOf3 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf3
     */
    type: WsServerMsgOneOf3TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf3TypeEnum = {
    SubnetsChanged: 'SubnetsChanged'
} as const;
export type WsServerMsgOneOf3TypeEnum = typeof WsServerMsgOneOf3TypeEnum[keyof typeof WsServerMsgOneOf3TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf4
 */
export interface WsServerMsgOneOf4 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf4
     */
    type: WsServerMsgOneOf4TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf4TypeEnum = {
    ExitNodesChanged: 'ExitNodesChanged'
} as const;
export type WsServerMsgOneOf4TypeEnum = typeof WsServerMsgOneOf4TypeEnum[keyof typeof WsServerMsgOneOf4TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf5
 */
export interface WsServerMsgOneOf5 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf5
     */
    type: WsServerMsgOneOf5TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf5TypeEnum = {
    DevicesChanged: 'DevicesChanged'
} as const;
export type WsServerMsgOneOf5TypeEnum = typeof WsServerMsgOneOf5TypeEnum[keyof typeof WsServerMsgOneOf5TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf6
 */
export interface WsServerMsgOneOf6 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf6
     */
    type: WsServerMsgOneOf6TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf6TypeEnum = {
    KeysChanged: 'KeysChanged'
} as const;
export type WsServerMsgOneOf6TypeEnum = typeof WsServerMsgOneOf6TypeEnum[keyof typeof WsServerMsgOneOf6TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf7
 */
export interface WsServerMsgOneOf7 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf7
     */
    type: WsServerMsgOneOf7TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf7TypeEnum = {
    UsersChanged: 'UsersChanged'
} as const;
export type WsServerMsgOneOf7TypeEnum = typeof WsServerMsgOneOf7TypeEnum[keyof typeof WsServerMsgOneOf7TypeEnum];

/**
 * 
 * @export
 * @interface WsServerMsgOneOf8
 */
export interface WsServerMsgOneOf8 {
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf8
     */
    group_uuid: string;
    /**
     * 
     * @type {string}
     * @memberof WsServerMsgOneOf8
     */
    type: WsServerMsgOneOf8TypeEnum;
}


/**
 * @export
 */
export const WsServerMsgOneOf8TypeEnum = {
    MembersChanged: 'MembersChanged'
} as const;
export type WsServerMsgOneOf8TypeEnum = typeof WsServerMsgOneOf8TypeEnum[keyof typeof WsServerMsgOneOf8TypeEnum];

